//import { API, Storage } from 'aws-amplify';
import { getUrl, uploadData } from "@aws-amplify/storage";
import { createCliente, createNotificaciones, createNotificacionesNuevas, createPProduccionGeneral, createPProduccionUltimoNumero, createProducto, createRecibaSerialesMP, createRecuperacion, createResumenOperacion, deleteRecibaSerialesMP, updateCliente, updateCotizacion, updateLocacion, updatePProduccionGeneral, updatePProduccionUltimoNumero, updatePlaneacionGeneral, updateReciba, updateRecibaSeriales, updateRecibaSerialesMP, updateResumenOperacion } from '../../graphql/mutations';
import { listClientes, listPProduccionUltimoNumeros } from '../../graphql/queries';
import { GetADatosROperacion, GetClientesID, GetCotizacionID, GetLocaciones, GetPProduccion, GetPProduccionGeneral, GetPProduccionGeneralID, GetPlaneacion, GetPlaneacionBaseGeneralID, GetPlaneacionGeneral, GetPlaneacionGeneralID, GetRecibaID, GetRecibaSeriales, GetRecibaSerialesID, GetRecibaSerialesIDMP, GetResumenOperacion, GetUsuarios } from './Queries';
import Moment from 'moment';
import { cambioUbicacionSeriales, ObtenerInventario, ObtenerSerialesPlaneacionBase, ObtenerSerialesPProduccion } from './DCUbicaciones';
import { generateClient } from "aws-amplify/api";
const API = generateClient();

/*Clientes */
//Guarda los datos de los clientes
export async function guardarCliente(formData, imagenRepetida, imagen, cotizacion) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, clienteID: "", productoID: "" };
    try {
        delete formData.imagename;
        if (imagenRepetida && cotizacion === false) {
            resultado.mensaje = "Ya existe una imagen con el mismo nombre: favor de seleccionar otra imagen o cambiar el nombre de la imagen y volver a intentarlo";
            resultado.color = "warning";
        } else if (!formData.cliente || !formData.image || !formData.activo || !formData.domicilio || !formData.colonia ||
            !formData.ciudad || !formData.estado || !formData.pais || !formData.codigoPostal || !formData.telefono || !formData.correo ||
            !formData.nombreContacto || !formData.puestoContacto || !formData.telefonoContacto || !formData.correoContacto) {
            resultado.mensaje = "Faltan datos: los campos marcados con un astirisco son obligatorios: ";
            resultado.color = "warning";
            resultado.deshabilitarBoton = false;
        } else {
            if (cotizacion === false && formData.image) {
                await uploadData({ key: imagen.name, data: imagen });//await Storage.put(imagen.name, imagen);
            }
            /*if (!formData.image || formData.image === "") {
                formData.image = "empresaIcono.png";
            }*/
            const idCotizacion = formData.idCotizacion;
            delete formData.idCotizacion;
            //Se guardan los datos del cliente
            let resultadoc = await API.graphql({ query: createCliente, variables: { input: formData } });
            const clienteCreado = resultadoc.data.createCliente;
            resultado.id = clienteCreado.id;
            if (formData.image && cotizacion === false) {
                const image = await getUrl({ key: formData.image });//await Storage.get(formData.image);
                formData.image = image.url.toString();
            }
            //Si se guardo de forma correcta el cliente, se procede a actualizar los datos de la cotización,
            // en caso de que los datos se obtuvieran de una cotización
            if (idCotizacion) {
                //Se obtienen los datos de la cotización por id 
                const cotizacion = await GetCotizacionID(idCotizacion);
                //Si se creó el cliente de manera correcta y se obtuvieron los datos de la cotización y esta activa .
                if (clienteCreado.id && cotizacion.id && cotizacion.activo === true) {
                    //Se guarda el producto asociado.                    
                    var producto = {};
                    producto.clienteID = clienteCreado.id;
                    producto.numerodeParte = cotizacion.numerodeParte;
                    producto.descripcion = cotizacion.descripcion;
                    producto.cotizacionID = cotizacion.id;
                    producto.divisa = cotizacion.divisa;
                    producto.precioUnitario = cotizacion.processEngineering !== "Plating Tool" ? cotizacion.finalSQFTPrice : "0";
                    if (cotizacion.processEngineering !== "Painting Tool") {
                        producto.precioUnitarioP = cotizacion.finalPSQFTPrice;
                    }
                    producto.cantidadporAnio = cotizacion.annualVolume;
                    producto.activo = cotizacion.activo;
                    producto.Reg_Ins_Usuario = clienteCreado.Reg_Ins_Usuario;
                    resultado.mensaje = "Problemas al guardar el producto: " + JSON.stringify(producto);
                    let productoCreado = await guardarProductos(producto, false, false, {}, {}, true)
                    resultado.productoID = productoCreado.productoID;

                    //Si se creó el producto de manera correcta, se actualizan los datos de la cotización
                    if (cotizacion === false) {
                        delete cotizacion.updatedAt;
                        delete cotizacion.createdAt;
                        delete cotizacion.__typename;
                        cotizacion.clienteID = clienteCreado.id;
                        cotizacion.clienteCatalogo = true;
                        cotizacion.clienteNContacto = false;
                        cotizacion.productoCreado = true;
                        if (productoCreado.id) {
                            cotizacion.productoID = productoCreado.id;
                        }
                        await API.graphql({ query: updateCotizacion, variables: { input: cotizacion } });
                    }

                }
            }
            //Se agrega el id del cliente recien creado.
            formData.id = clienteCreado.id;
            resultado.mensaje = "Datos guardados";
            resultado.color = "primary";
            resultado.completo = true;
        }
    } catch (e) {
        resultado.mensaje = "No fue posible realizar la operación: favor de comunicarse a sistemas";
        resultado.color = "warning";
        resultado.deshabilitarBoton = false;
    }
    return resultado;
};
//actualiza  los datos de los clientes
export async function actualizarClientes(formData, editarImagen, imagen, mClientes, cotizacion) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, clienteID: "", productoID: "", error: false };
    try {
        if (!formData.cliente || !formData.image || !formData.activo || !formData.domicilio || !formData.colonia ||
            !formData.ciudad || !formData.estado || !formData.pais || !formData.codigoPostal || !formData.telefono || !formData.correo ||
            !formData.nombreContacto || !formData.puestoContacto || !formData.telefonoContacto || !formData.correoContacto) {
            resultado.mensaje = "Faltan datos: los campos marcados con un asterisco son obligatorios";
            resultado.color = "warning";
            resultado.deshabilitarBoton = false;
        } else {
            if (mClientes !== formData) {
                //Se revisa si hay concurrencia.
                let filter = {
                    id: {
                        eq: formData.id
                    }
                };
                //const apiData = await API.graphql({ query: listClientes, variables: { filter: filter, limit: 100000000 } });
                var nextToken = null;
                var apiData = [];
                do {
                    const apiOData = await API.graphql({ query: listClientes, variables: { filter: filter, limit: 100000000, nextToken } });
                    const odatos = await apiOData.data.listClientes.items;
                    nextToken = await apiOData.data.listClientes.nextToken;
                    apiData = await [...apiData, ...odatos];
                } while (nextToken != null);

                const clientesFromAPI = await apiData;
                //Si la fecha de actualización es la misma, no hay concurrencia y se procede con la modificación 
                if (clientesFromAPI[0].updatedAt === formData.updatedAt) {
                    delete formData.createdAt;
                    delete formData.updatedAt;
                    delete formData.__typename;
                    resultado.mensaje = "Antes de intentar guardar la imagen";
                    if (cotizacion === false) {
                        delete formData.imagename;
                        if (!editarImagen)
                            delete formData.image;
                        else
                            await uploadData({ key: imagen.name, data: imagen });//await Storage.put(imagen.name, imagen);
                    }
                    resultado.mensaje = "Despues de intentar guardar la imagen";

                    await API.graphql({ query: updateCliente, variables: { input: formData } });
                    resultado.mensaje = "Despues de guardar los datos";
                    if (cotizacion === false) {
                        if (formData.image) {
                            const image = await getUrl({ key: formData.image });//await Storage.get(formData.image);
                            formData.image = image.url.toString();
                        }
                    }
                    resultado.mensaje = "Datos guardados";
                    resultado.color = "primary";
                    resultado.deshabilitarBoton = false;
                    resultado.completo = true;
                } else { //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos                                        
                    resultado.mensaje = "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
                        " volver a intentarlo";
                    resultado.color = "warning";
                }
            } else {
                resultado.mensaje = "No se detectaron cambios";
                resultado.color = "primary";
                resultado.completo = true;
            }
        }
    } catch (e) {
        resultado.mensaje = "No fue posible realizar la operación: favor de comunicarse a sistemas";
        resultado.color = "warning";
        resultado.deshabilitarBoton = false;
        resultado.error = true;
    }
    return resultado;
}
/*Productos */
//Guarda los datos de los productos
export async function guardarProductos(formData, imagenRepetida, DocumentoRepetido, formImages, formDocuments, cotizacion) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, productoID: "" };

    try {

        if (formData.imagename)
            delete formData.imagename;
        delete formData.indexpag;
        delete formData.documentodeEspecificacionesurl;

        if (!formData.clienteID || !formData.numerodeParte || !formData.divisa ||
            (!formData.Pcoat && !formData.Ecoat && !formData.Platinado) ||
            (formData.Pcoat && !formData.precioUnitarioPC) || (formData.Ecoat && !formData.precioUnitario) ||
            (formData.Platinado && !formData.precioUnitarioP) || !formData.cantidadporAnio || !formData.rackTipo) {
            resultado.mensaje = "Faltan datos: los campos marcados con un asterisco son obligatorios";
            resultado.color = "warning";
            resultado.deshabilitarBoton = false;
            /*setMensajeAlert("Faltan datos: los campos marcados con un asterisco son obligatorios" + " Cliente: "+ formData.clienteID+
             " Número de parte: " + formData.numerodeParte + " Descripción: " + formData.descripcion +
            " Divisa: " + formData.divisa + " Precio unitario: " + formData.precioUnitario + " Cantidad por año: " + formData.cantidadporAnio);*/
        } else if (imagenRepetida || DocumentoRepetido) {
            resultado.mensaje = "Uno o más archivos ya existen en la base de datos: favor de revisar y volver a intentarlo";
            resultado.color = "warning";
            resultado.deshabilitarBoton = false;
        } else {
            if (cotizacion === false) {
                //Guardando las imagenes
                if (formImages.image.name)
                    await uploadData({ key: formImages.image.name, data: formImages.imagen }); //await Storage.put(formImages.image.name, formImages.image);
                if (formImages.image1.name)
                    await uploadData({ key: formImages.image1.name, data: formImages.imagen1 }); //await Storage.put(formImages.image1.name, formImages.image1);
                if (formImages.image2.name)
                    await uploadData({ key: formImages.image2.name, data: formImages.imagen2 }); //await Storage.put(formImages.image2.name, formImages.image2);
                if (formImages.image3.name)
                    await uploadData({ key: formImages.image3.name, data: formImages.imagen3 }); //await Storage.put(formImages.image3.name, formImages.image3);
                if (formImages.image4.name)
                    await uploadData({ key: formImages.image4.name, data: formImages.imagen4 }); //await Storage.put(formImages.image4.name, formImages.image4);
                if (formImages.image5.name)
                    await uploadData({ key: formImages.image5.name, data: formImages.imagen5 }); //await Storage.put(formImages.image5.name, formImages.image5);
                if (formImages.image6.name)
                    await uploadData({ key: formImages.image6.name, data: formImages.imagen6 }); //await Storage.put(formImages.image6.name, formImages.image6);
                if (formImages.image7.name)
                    await uploadData({ key: formImages.image7.name, data: formImages.imagen7 }); //await Storage.put(formImages.image7.name, formImages.image7);
                if (formImages.image8.name)
                    await uploadData({ key: formImages.image8.name, data: formImages.imagen8 }); //await Storage.put(formImages.image8.name, formImages.image8);
                if (formImages.image9.name)
                    await uploadData({ key: formImages.image9.name, data: formImages.imagen9 }); //await Storage.put(formImages.image9.name, formImages.image9);

                //Guardando los documentos            
                if (formDocuments.documentodeEspecificaciones.name)
                    await uploadData({ key: formDocuments.documentodeEspecificaciones.name, data: formDocuments.documentodeEspecificaciones });//await Storage.put(formDocuments.documentodeEspecificaciones.name, formDocuments.documentodeEspecificaciones);
                if (formDocuments.documento1.name)
                    await uploadData({ key: formDocuments.documento1.name, data: formDocuments.documento1 });//await Storage.put(formDocuments.documento1.name, formDocuments.documento1);
                if (formDocuments.documento2.name)
                    await uploadData({ key: formDocuments.documento2.name, data: formDocuments.documento2 });//await Storage.put(formDocuments.documento2.name, formDocuments.documento2);
                if (formDocuments.documento3.name)
                    await uploadData({ key: formDocuments.documento3.name, data: formDocuments.documento3 });//await Storage.put(formDocuments.documento3.name, formDocuments.documento3);
                if (formDocuments.documento4.name)
                    await uploadData({ key: formDocuments.documento4.name, data: formDocuments.documento4 });//await Storage.put(formDocuments.documento4.name, formDocuments.documento4);
                if (formDocuments.documento5.name)
                    await uploadData({ key: formDocuments.documento5.name, data: formDocuments.documento5 });//await Storage.put(formDocuments.documento5.name, formDocuments.documento5);
                if (formDocuments.documento6.name)
                    await uploadData({ key: formDocuments.documento6.name, data: formDocuments.documento6 });//await Storage.put(formDocuments.documento6.name, formDocuments.documento6);
                if (formDocuments.documento7.name)
                    await uploadData({ key: formDocuments.documento7.name, data: formDocuments.documento7 });//await Storage.put(formDocuments.documento7.name, formDocuments.documento7);
                if (formDocuments.documento8.name)
                    await uploadData({ key: formDocuments.documento8.name, data: formDocuments.documento8 });//await Storage.put(formDocuments.documento8.name, formDocuments.documento8);
                if (formDocuments.documento9.name)
                    await uploadData({ key: formDocuments.documento9.name, data: formDocuments.documento9 });//await Storage.put(formDocuments.documento9.name, formDocuments.documento9);
            }

            let resultadop = await API.graphql({ query: createProducto, variables: { input: formData } });
            const productoCreado = resultadop.data.createProducto;
            if (cotizacion === false) {
                if (formData.image) {
                    const image = await getUrl({ key: formData.image });//await Storage.get(formData.image);
                    formData.image = image.url.toString();
                }
            }
            resultado.mensaje = "Datos guardados";
            resultado.color = "primary";
            resultado.completo = true;
            resultado.productoID = productoCreado.id;
            const clienteN = await GetClientesID(formData.clienteID);
            //Se crea una notificación de la creación del nuevo número de parte.
            const usuariosNot = await GetUsuarios({ and: [{ activo: { eq: true } }, { Notificaciones: { eq: true } }, { usuario: { ne: formData.Reg_Ins_Usuario } }] });
            const nombres = usuariosNot.map(u => u.usuario).join(',');
            const notificaciones = {
                modulo: cotizacion === false ? "Productos" : "Cotizaciones",
                Accion: "Nuevos números de parte se han creado",
                notificacion: "Se ha creado el número de parte " + formData.numerodeParte + " del cliente " + clienteN.cliente,
                fecha: Moment(new Date()).format("YYYY-MM-DD"),
                hora: Moment(new Date()).format("HH:mm"),
                leido: false,
                usuarioDe: formData.Reg_Ins_Usuario,
                usuarioPara: "," + nombres + ",",
                paraSoporte: false,
                activo: true,
                Reg_Ins_Usuario: formData.Reg_Ins_Usuario
            };
            //Se guardan los datos de la notificación.
            let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
            //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
            notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
            await Promise.all(
                usuariosNot.map(async (not, i) => {
                    const notific = { ...notificaciones, usuarioPara: not.usuario };
                    //Se establece para qué usuario es la notificación                    
                    await API.graphql({ query: createNotificacionesNuevas, variables: { input: notific } });
                })
            );
        }

    } catch (e) {
        resultado.mensaje = "No fue posible realizar la operación: favor de comunicarse a sistemas1 " + JSON.stringify(formData);
        resultado.color = "warning";
    }
    return resultado;
}
/*RecibaSeriales y RecibaSerialesMP */
//Pone el indicador de piezasEnPlanta en  RecibaSeriales y crea un registro en RecibaSerialesMP
export async function regresarAPlanta(recibaI, userName) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, reciba: {} };
    try {
        if ((recibaI.piezasEmbarcadas ? recibaI.piezasEmbarcadas : 0) < recibaI.cantidadRecibida) {
            const reciba = await GetRecibaSerialesID(recibaI.id);
            /*const recibaMP= await GetRecibaSerialesIDMP(recibaI.recibaSerialMPID);
            if (!recibaMP.id){*/
            //Se crean los datos en recibaSerialesMP                
            const recibaSerialIDOR = reciba.id;
            reciba.piezasEnPlanta = true;
            reciba.Reg_Mod_Usuario = userName;
            delete reciba.recibaSerialMPID;
            delete reciba.id;
            delete reciba.updatedAt;
            delete reciba.__typename;
            delete reciba.createdAt;
            resultado.mensaje = "Error al crear reciba serialesMP" + JSON.stringify(reciba);
            resultado.color = "warning";
            let serialesMP = await API.graphql({
                query: createRecibaSerialesMP,
                variables: { input: { ...reciba, recibaSerialID: recibaSerialIDOR } },
            });
            //Se obtienen los datos de recibaSerialesMP recién creados
            var recibaMPCreada = serialesMP.data.createRecibaSerialesMP;
            reciba.recibaSerialMPID = recibaMPCreada.id;
            reciba.id = recibaSerialIDOR;
            //}
            //Se actualizan los datos en recibaSeriales          
            resultado.mensaje = "Error al actualizar reciba seriales";
            resultado.color = "warning";
            let upRecibaS = await API.graphql({
                query: updateRecibaSeriales,
                variables: { input: reciba },
            });
            const recibaActualizada = upRecibaS.data.updateRecibaSeriales;
            //Se actualizan los datos en recibaSerialesMP
            const recibaSerialMPID = reciba.recibaSerialMPID;
            if (reciba.recibaSerialMPID) {
                delete reciba.recibaSerialMPID;
                resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(reciba);
                resultado.color = "warning";
                await API.graphql({
                    query: updateRecibaSerialesMP, variables: {
                        input: {
                            ...reciba, id: recibaSerialMPID,
                            rsUpdatedAt: recibaActualizada.updatedAt, recibaSerialID: reciba.id
                        }
                    },
                });
            }
            resultado.mensaje = "Operación exitosa; Se marcó el material en planta del SerialBTI:  " + reciba.serialRecibaBTI;
            resultado.color = "info";
            resultado.completo = true;
            return resultado;
        } else {
            resultado.mensaje = "El material está marcdo como embarcado, actualmente solo se puede marcar en planta material que no ha sido embarcado";
            resultado.color = "warning";
            return resultado;
        }

    } catch (e) {
        return resultado;
    }
}

//Procedimiento especial para marcar el material fuera de planta
export async function marcarMaterialFueradePlanta(recibas, userName) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, reciba: {} };
    try {
        //Se obtienen los datos de la reciba por ID        
        const recibam = await GetRecibaSerialesID(recibas.recibaSerialID);
        if (recibam.id) {
            //Piezas a embarcar que se guardan en recibaSeriales
            delete recibam.createdAt;
            delete recibam.updatedAt;
            delete recibam.__typename;
            recibam.piezasEnPlanta = false;
            recibam.Reg_Mod_Usuario = userName;
            resultado.mensaje = "Problemas al actualizar los datos del serial " + " " + JSON.stringify(recibam);
            resultado.color = "warning";
            let upRecibaS = await API.graphql({
                query: updateRecibaSeriales,
                variables: { input: recibam },
            });
            if (recibam.recibaSerialMPID) {
                //Se eliminan los datos en la tabla de serialesMP.
                resultado.mensaje = "No se pudo eliminar el serial de la tabla temporal; ";
                resultado.color = "warning";
                await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: recibam.recibaSerialMPID, } } });
            }
            resultado.mensaje = "Operación exitosa, se marcó fuera de planta el serial " + recibam.serialRecibaBTI + " de la reciba " + recibam.numero;
            resultado.color = "primary";
            resultado.completo = true;
        } else {
            resultado.mensaje = "No se encontraron datos para marcar fuera de planta, si el problema persiste, favor de comunicarte a sistemas";
            resultado.color = "warning";
        }
        return resultado;
    } catch (e) {
        return resultado;
    }
}
//Actualiza los datos de  planeación y plan de Producción general
export async function actualizarPPPGeneralM(fecha, userName) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [] };
    try {
        //Filtro por material en planta
        //Se obtienen los datos de las planeaciones          
        var fechas = [];
        var fechaActual = Moment(fecha).format("YYYY-MM-DD");
        let filter = {
            and: [
                {
                    fechaDePlaneacion: {
                        eq: fechaActual,
                    }
                },
                {
                    activo: {
                        eq: true,
                    }
                },
            ]
        };
        //Se actualizan los datos de planeación
        const pg = await GetPlaneacionGeneral(filter);
        if (pg[0]) {
            var ids = [];
            const planeaciong = pg[0];
            const apiData = await GetPlaneacion(filter);
            //Se ordenan los datos
            resultado.mensaje = "Datos obtenidos " + JSON.stringify(apiData);
            resultado.color = "warning";
            //Se ordenan los datos por fecha de reciba
            const datosFromAPI = apiData.sort((a, b) =>
                a.fechaDePlaneacion > b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion < b.fechaDePlaneacion ? -1 : 0);
            await Promise.all(datosFromAPI.map(async (planeacion, i) => {
                //Se concatenan los registros de la planeación en cuestión
                ids.push({ id: planeacion.id });
                fechas.push({
                    fechaDePlaneacion: fechaActual,
                    PlaneacionIDS: planeacion.id,
                    numero: planeacion.numero,
                    activo: true,
                    Reg_Mod_Usuario: userName
                });
                return planeacion;
            }))
            delete planeaciong.updatedAt;
            delete planeaciong.createdAt;
            delete planeaciong.__typename;
            planeaciong.PlaneacionIDS = ids;
            planeaciong.Reg_Mod_Usuario = userName;
            resultado.mensaje = "Problemas al actualizar planeación general " + JSON.stringify(planeaciong);
            resultado.color = "warning";
            await API.graphql({ query: updatePlaneacionGeneral, variables: { input: planeaciong }, });
        }
        //Se actualizan los datos de producción gereral
        const ppg = await GetPProduccionGeneral(filter);
        if (ppg[0]) {
            const pproducciong = ppg[0];
            var ids = [];
            var idsRS = [];
            const apiData = await GetPProduccion(filter);
            //Se ordenan los datos
            resultado.mensaje = "Datos obtenidos " + JSON.stringify(apiData);
            resultado.color = "warning";
            //Se ordenan los datos por fecha de reciba
            const pproduccionFromAPI = apiData.sort((a, b) =>
                a.fechaDePlaneacion > b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion < b.fechaDePlaneacion ? -1 : 0);
            await Promise.all(pproduccionFromAPI.map(async (pproduccion, i) => {
                //Se concatenan los registros de la planeación en cuestión
                ids.push({ id: pproduccion.id });
                idsRS.push({ id: pproduccion.recibaSerialID });
                fechas.push({
                    fechaDePlaneacion: fechaActual,
                    PlaneacionIDS: pproduccion.id,
                    numero: pproduccion.numero,
                    activo: true,
                    Reg_Mod_Usuario: userName
                });
                return pproduccion;
            }))
            delete pproducciong.updatedAt;
            delete pproducciong.createdAt;
            delete pproducciong.__typename;
            pproducciong.PProduccionIDS = ids;
            pproducciong.recibaSerialIDS = idsRS;
            pproducciong.Reg_Mod_Usuario = userName;
            resultado.mensaje = "Problemas al actualizar planeación general " + JSON.stringify(pproducciong);
            resultado.color = "warning";
            await API.graphql({ query: updatePProduccionGeneral, variables: { input: pproducciong }, });
        }
        resultado.registros = [...fechas];
        resultado.completo = true;
        resultado.mensaje = "Operación exitosa";
        resultado.color = "primary";
        return resultado;
    } catch (e) {
        return resultado;
    }

}
//Actualiza los datos de  planeación y plan de Producción general específicos
export async function actualizarPPPGeneralE(planeaciongID, pproducciongID, fecha, userName) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [] };
    try {
        //Filtro por material en planta
        //Se obtienen los datos de las planeaciones          
        var fechas = [];
        var fechaActual = Moment(fecha).format("YYYY-MM-DD");
        let filter = {
            and: [
                {
                    fechaDePlaneacion: {
                        eq: fechaActual,
                    }
                },
                {
                    activo: {
                        eq: true,
                    }
                },
            ]
        };
        //Se actualizan los datos de planeación
        const planeaciong = await GetPlaneacionGeneralID(planeaciongID);
        if (planeaciong.id) {
            var ids = [];
            const apiData = await GetPlaneacion(filter);
            //Se ordenan los datos
            resultado.mensaje = "Datos obtenidos " + JSON.stringify(apiData);
            resultado.color = "warning";
            //Se ordenan los datos por fecha de reciba
            const datosFromAPI = apiData.sort((a, b) =>
                a.fechaDePlaneacion > b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion < b.fechaDePlaneacion ? -1 : 0);
            await Promise.all(datosFromAPI.map(async (planeacion, i) => {
                //Se concatenan los registros de la planeación en cuestión
                ids.push({ id: planeacion.id });
                fechas.push({
                    fechaDePlaneacion: fechaActual,
                    PlaneacionIDS: planeacion.id,
                    numero: planeacion.numero,
                    activo: true,
                    Reg_Mod_Usuario: userName
                });
                return planeacion;
            }))
            delete planeaciong.updatedAt;
            delete planeaciong.createdAt;
            delete planeaciong.__typename;
            planeaciong.PlaneacionIDS = ids;
            planeaciong.Reg_Mod_Usuario = userName;
            resultado.mensaje = "Problemas al actualizar planeación general " + JSON.stringify(planeaciong);
            resultado.color = "warning";
            await API.graphql({ query: updatePlaneacionGeneral, variables: { input: planeaciong }, });
        }
        //Se actualizan los datos de producción gereral
        const pproducciong = await GetPProduccionGeneralID(pproducciongID);
        if (pproducciong.id) {
            var ids = [];
            var idsRS = [];
            const apiData = await GetPProduccion(filter);
            //Se ordenan los datos
            resultado.mensaje = "Datos obtenidos " + JSON.stringify(apiData);
            resultado.color = "warning";
            //Se ordenan los datos por fecha de reciba
            const pproduccionFromAPI = apiData.sort((a, b) =>
                a.fechaDePlaneacion > b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion < b.fechaDePlaneacion ? -1 : 0);
            await Promise.all(pproduccionFromAPI.map(async (pproduccion, i) => {
                //Se concatenan los registros de la planeación en cuestión
                ids.push({ id: pproduccion.id });
                idsRS.push({ id: pproduccion.recibaSerialID });
                fechas.push({
                    fechaDePlaneacion: fechaActual,
                    PlaneacionIDS: pproduccion.id,
                    numero: pproduccion.numero,
                    activo: true,
                    Reg_Mod_Usuario: userName
                });
                return pproduccion;
            }))
            delete pproducciong.updatedAt;
            delete pproducciong.createdAt;
            delete pproducciong.__typename;
            pproducciong.PProduccionIDS = ids;
            pproducciong.recibaSerialIDS = idsRS;
            pproducciong.Reg_Mod_Usuario = userName;
            resultado.mensaje = "Problemas al actualizar planeación general " + JSON.stringify(pproducciong);
            resultado.color = "warning";
            await API.graphql({ query: updatePProduccionGeneral, variables: { input: pproducciong }, });
        }
        resultado.registros = [...fechas];
        resultado.completo = true;
        resultado.mensaje = "Operación exitosa";
        resultado.color = "primary";
        return resultado;
    } catch (e) {
        return resultado;
    }

}

//Actualiza los datos de  recibas específicas
export async function actualizarRecibas(reciba, userName) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [] };
    try {
        //Se obtienen los datos        
        let filter = {
            and: [
                {
                    numero: {
                        eq: reciba.numero,
                    }
                },
                {
                    activo: {
                        eq: true,
                    }
                },
            ]
        };
        //Se actualizan los datos de la reciba
        const recibaGen = await GetRecibaID(reciba.id);
        if (recibaGen.id) {
            var serialesID = [];
            var serialesBTI = "";
            const apiData = await GetRecibaSeriales(filter);
            //Se ordenan los datos
            resultado.mensaje = "Datos obtenidos " + JSON.stringify(apiData);
            resultado.color = "warning";
            //Se ordenan los datos por fecha de reciba
            const datosFromAPI = apiData.sort((a, b) =>
                a.serial > b.serial ? 1 : a.serial < b.serial ? -1 : 0);
            await Promise.all(datosFromAPI.map(async (recibas, i) => {
                //Se concatenan los registros de los seriales en cuestión
                serialesID.push({ id: recibas.id });
                serialesBTI = serialesBTI === "" ? recibas.serialRecibaBTI : serialesBTI + "," + recibas.serialRecibaBTI;
                return recibas;
            }))
            delete recibaGen.updatedAt;
            delete recibaGen.createdAt;
            delete recibaGen.__typename;
            recibaGen.serialesBTI = serialesBTI;
            recibaGen.serialesID = serialesID;
            recibaGen.Reg_Mod_Usuario = userName;
            resultado.mensaje = "Problemas al actualizar planeación general " + JSON.stringify(recibaGen);
            resultado.color = "warning";
            let result = await API.graphql({ query: updateReciba, variables: { input: recibaGen }, });
            resultado.registros = result.data.updateReciba;
        }
        resultado.completo = true;
        resultado.mensaje = "Operación exitosa";
        resultado.color = "primary";
        return resultado;
    } catch (e) {
        return resultado;
    }

}

// Marca material específico como pintado.
export async function clicPintado(pProduccionPintado, fechaPlaneacion, userName, moduloP) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [], pproduccionGID: "" };
    //subscriptions.unsubscribe();
    try {
        var pConcurrencia = false;
        //Se obtienen los datos del plan de producción por número para revisar la concurrencia
        //Se obtienen los datos del serial para revisar concurrencia
        //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de piezasenPintado  en pProduccion
        //Además, se guarda la ubicación en Ubicaciones
        if (pConcurrencia === false) {
            //resultado.mensaje ="Empezando";
            //Se obtienen los datos del plan de producción general
            var pproduccionGID = "";
            const pproduccionG = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { activo: { eq: true } }] });
            //Se actualiza el registro general de plan de producción.          
            if (pproduccionG.length > 0) {
                pproduccionGID = pproduccionG[0].id;
                var brecibaSerialIDS = pproduccionG[0].recibaSerialIDS ? pproduccionG[0].recibaSerialIDS : [];
                await Promise.all(pProduccionPintado.map(async (pproduccion) => {
                    const datoRepetido = brecibaSerialIDS[0] ? await brecibaSerialIDS.filter(datosPProduccion =>
                        datosPProduccion.includes(pproduccion.recibaSerialID)) : [];
                    if (!datoRepetido[0]) {
                        brecibaSerialIDS = brecibaSerialIDS[0] ?
                            [...brecibaSerialIDS, { id: pproduccion.recibaSerialID }] :
                            [{ id: pproduccion.recibaSerialID }];
                    }
                }));
                //Se guardan los datos del serial en el plan de producción general
                const rPProduccion = {
                    ...pproduccionG[0],
                    recibaSerialIDS: brecibaSerialIDS,
                    Reg_Mod_Usuario: userName
                };

                delete rPProduccion.createdAt;
                delete rPProduccion.updatedAt;
                delete rPProduccion.__typename;
                resultado.mensaje = "Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion);
                await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
            } else { //Si no existe, se crea el número de plan de producción en la tabla PProduccionUltimoNumero
                resultado.mensaje = "Obteniendo datos; 2";
                var numeroUP = 1;
                const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                    numeroUP = ultimaplaneacion.numero + 1;
                    ultimaplaneacion.numero = numeroUP;

                    delete ultimaplaneacion.createdAt;
                    delete ultimaplaneacion.updatedAt;
                    delete ultimaplaneacion.__typename;
                    ultimaplaneacion.Reg_Mod_Usuario = userName;
                    resultado.mensaje = "Problemas al actualizar updatePProduccionUltimoNumero";
                    await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                    return ultimaplaneacion;
                }))
                if (!ultimapFromAPI.length) {
                    await API.graphql({
                        query: createPProduccionUltimoNumero, variables: {
                            input: {
                                numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                            }
                        }
                    });
                }
                //Se crea el registro de la plan de producción general
                var brecibaSerialIDS = [];
                resultado.mensaje = "Obteniendo datos; 3";
                await Promise.all(pProduccionPintado.map(async (pproduccion) => {
                    const datoRepetido = brecibaSerialIDS[0] ? await brecibaSerialIDS.filter(datosPProduccion =>
                        datosPProduccion.includes(pproduccion.recibaSerialID)) : [];
                    if (!datoRepetido[0]) {
                        brecibaSerialIDS = brecibaSerialIDS[0] ?
                            [...brecibaSerialIDS, { id: pproduccion.recibaSerialID }] :
                            [{ id: pproduccion.recibaSerialID }];
                    }
                }));
                resultado.mensaje = "Problemas al guardar la planeación general 1 - Pintado";
                let resulppg = await API.graphql({
                    query: createPProduccionGeneral, variables: {
                        input: {
                            fechaDePlaneacion: fechaPlaneacion,
                            numero: numeroUP,
                            espacioVacio: 0,
                            porSerial: true,
                            recibaSerialIDS: brecibaSerialIDS,
                            activo: true,
                            Reg_Ins_Usuario: userName
                        }
                    }
                });
                pproduccionGID = resulppg.data.createPProduccionGeneral.id;
                resultado.pproduccionGID = pproduccionGID;
            }
            //Se determina el material que pasará de carga a pintado
            var registrosErr = 0;
            var concurrencias = "";
            var terminadoS = "";
            var terminadoyconcurrenciaS = "";
            var correctas = "";
            var fueradePlanta = "";
            var problemasUbicacion = "";
            await Promise.all(
                pProduccionPintado.map(async (pproduccion) => {
                    //Se obtiene el registro más reciente del serial en el plan de producción, para revisar
                    // concurrencia y el valor 
                    if (pproduccion.recibaSerialID) {
                        //Se obtienen los datos de reciba seriales por id
                        const recibaFromAPI = await GetRecibaSerialesID(pproduccion.recibaSerialID);
                        //Se asigna el valor de la fecha de la pintado
                        const fecha = Moment(new Date()).format("YYYY-MM-DD");
                        const hora = Moment(new Date()).format("HH:mm");
                        const fechahora = Moment(fecha + " " + hora).format("YYYY-MM-DD HH:mm");
                        const piezasEnCargando = (pproduccion.piezasenCarga ? pproduccion.piezasenCarga - (pproduccion.piezasenPintado ? pproduccion.piezasenPintado : 0) : 0);
                        //Se asigna el valor de la fecha de pintado
                        const piezasfechayhora = piezasEnCargando + " " + fechahora;
                        pproduccion.pintadoFechaHora = !pproduccion.pintadoFechaHora ?
                            piezasfechayhora : pproduccion.pintadoFechaHora + ", " + piezasfechayhora;
                        if (recibaFromAPI.piezasEnPlanta === true) {
                            //Creación o actualización de registro en pProducción   
                            const datosPintado = {
                                produccionGID: pproduccionGID, fechaDePlaneacion: pproduccion.fechaDePlaneacion,
                                fecha: fecha, hora: hora, cantidadPiezas: pproduccion.cantidadPiezas,
                                piezasenPintado: piezasEnCargando, racks: pproduccion.racks,
                                ciclos: pproduccion.ciclos, Reg_Ins_Usuario: userName, modulo: moduloP
                            }
                            //Se actualizan los datos en recibaSeriales
                            resultado.mensaje = "Problemas al obtener los datos de ubicación";
                            if (recibaFromAPI.id) {
                                //Se cambia la ubicación del material de almacén a carga
                                const loacionAnterior = "Carga";
                                const ubicacionAnterior = "Producción";
                                const loacionPiezas = "Pintado";;
                                const ubicacionPiezas = "Producción";
                                const cantidadPiezas = piezasEnCargando;
                                var cambioUbicacionAux = [];
                                resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material 1";//"Antes de obtener los datos del cambio de ubicación";
                                cambioUbicacionAux = await cambioUbicacionSeriales(
                                    recibaFromAPI,
                                    ubicacionAnterior,
                                    loacionAnterior,
                                    ubicacionPiezas,
                                    loacionPiezas,
                                    cantidadPiezas);
                                resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material 2";//"Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAux);
                                if (cambioUbicacionAux.mensaje != "") {
                                    resultado.mensaje = cambioUbicacionAux.mensaje;
                                    resultado.color = cambioUbicacionAux.color;
                                    return resultado;
                                } else {
                                    recibaFromAPI.ultimaUbicacion = cambioUbicacionAux.sUltimaU;
                                    recibaFromAPI.rubicaciones = cambioUbicacionAux.sUbicaciones
                                    //resultado.mensaje = "Ubicaciones agrupadas";
                                }
                                const datosPintandor = recibaFromAPI.registroPintado ? recibaFromAPI.registroPintado : [];
                                await datosPintandor.push(datosPintado);

                                recibaFromAPI.registroPintado = datosPintandor;
                                recibaFromAPI.pintadoFechaHora = pproduccion.pintadoFechaHora;
                                delete recibaFromAPI.createdAt;
                                delete recibaFromAPI.updatedAt;
                                delete recibaFromAPI.__typename;

                                delete recibaFromAPI.piezasCtnaRecuperadas;
                                delete recibaFromAPI.piezasInspeccion;
                                delete recibaFromAPI.piezasInspeccionPC;
                                delete recibaFromAPI.piezasIRecuperacion;
                                delete recibaFromAPI.piezasCRecuperacion;
                                delete recibaFromAPI.PiezasCtnaRecuperacion;
                                delete recibaFromAPI.piezasTRecuperacion;
                                delete recibaFromAPI.piezasRecuperadas;

                                recibaFromAPI.piezasenPintado = recibaFromAPI.piezasenCarga;
                                recibaFromAPI.Reg_Mod_Usuario = userName;
                                resultado.mensaje = "Operación errónea; Problemas al guardar datos de seriales ";
                                let upRecibaS = await API.graphql({
                                    query: updateRecibaSeriales,
                                    variables: { input: recibaFromAPI },
                                });
                                //Se actualizan los datos en recibaSerialesMP
                                const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                                if (recibaFromAPI.recibaSerialMPID) {
                                    delete recibaFromAPI.recibaSerialMPID;
                                    resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI);
                                    await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                                }
                                //Se registra el dato de Resultado de operación
                                pproduccion.piezasEnpintando = piezasEnCargando;
                                const rOperacion = await manageResumenOperacion(fecha, pproduccion, "Producción", userName, pproduccionGID);
                                //Liberar locación en caso de que la cantidad en pintado sea igual a la cantidad que se recibió.
                                //Obtener la cantidad que se recibió.
                                const cantidadRecibida = recibaFromAPI.cantidadRecibida;
                                //Revisar si la cantidad que se recibió es la misma de pintado
                                if (cantidadRecibida === pproduccion.piezasenPintado) {
                                    //Obtener el registro de la locación en ubicación que se tiene que liberar
                                    const ubicacionAlmacen = await cambioUbicacionAux.sUbicaciones
                                        .filter((ubicacion) => ubicacion.ubicacion === "Almacén")
                                        .sort((a, b) =>
                                            a.orden < b.orden ? 1 : a.orden > b.orden ? -1 : 0
                                        );
                                    //resultado.mensaje ="Obteniendo datos, Ubicación:" + JSON.stringify(ubicacionAlmacen);
                                    if (ubicacionAlmacen[0].locacion) {
                                        //const apiLocData = await API.graphql({ query: listLocacions, variables: { filter: filterl, limit: 100000000 } });
                                        const locacionSinfiltro = await GetLocaciones({
                                            locacion: { eq: ubicacionAlmacen[0].locacion },
                                        }); //.data.listLocacions.items;
                                        //resultado.mensaje ="Obteniendo datos, Locación: " + JSON.stringify(ubicacionAlmacen[0].locacion) + " Array: " +  JSON.stringify(locacionSinfiltro) ;
                                        //Liberar la locación
                                        if (locacionSinfiltro.length > 0)
                                            liberarlocacionb(
                                                locacionSinfiltro[0],
                                                ubicacionAlmacen[0].espacioOcupado,
                                                userName
                                            );
                                    }
                                }
                                correctas = (correctas === "" ? "" : correctas + ", ") + pproduccion.serialRecibaBTI
                            } else {
                                registrosErr++;
                                fueradePlanta = (fueradePlanta === "" ? "" : fueradePlanta + ", ") + pproduccion.serialRecibaBTI;
                            }
                        } else {
                            registrosErr++;
                            problemasUbicacion = (problemasUbicacion === "" ? "" : problemasUbicacion + ", ") + pproduccion.serialRecibaBTI;
                        }
                    }
                })
            );
            if (registrosErr === 0) {
                resultado.color = "primary";
                resultado.mensaje = "Operación exitosa";
                resultado.completo = true;
                return resultado;
            } else {
                resultado.mensaje = "Operación terminada;" + (correctas ? (" Operación exitosa para los seriales: " + correctas + ".") : "")
                    + (terminadoyconcurrenciaS ? (" No se pudo terminar la operación por concurrencia y finalización de plan de producción para: " + terminadoyconcurrenciaS + ".") : "")
                    + (concurrencias ? (" No se pudo terminar la operación por concurrencia para: " + concurrencias + ".") : "")

                    + (fueradePlanta ? (" No se pudo terminar la operación por que está marcado fuera de planta para: " + fueradePlanta + ".") : "")
                    + (problemasUbicacion ? (" No se pudo terminar la operación por problemas de ubicación para: " + problemasUbicacion + ".") : "")

                    + (terminadoS ? (" No se pudo terminar la operación por finalización de plan de producción para: " + terminadoS + ".") : "");
                resultado.color = "warning";
                return resultado;
            }
            //await fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
        } else {
            //Si  hay concurrencia se tienen que actualizar los datos
            window.scrollTo(0, 0);
            resultado.mensaje = "No fue posible realizar la operación: existe concurrencia, se actualizó la información, favor de revisar los datos y " +
                " volver a intentarlo";
            //fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
            return resultado;

        }
    } catch (e) {
        resultado.color = "warning";
        return resultado;
    }
}
// Marca material específico como pintado en Powerd Coat.
export async function clicPintadoPC(pProduccionPintado, fechaPlaneacion, userName, moduloP) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [], pproduccionGID: "" };
    //subscriptions.unsubscribe();
    try {
        var pConcurrencia = false;
        //Se obtienen los datos del plan de producción por número para revisar la concurrencia
        //Se obtienen los datos del serial para revisar concurrencia
        //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de piezasenPintado  en pProduccion
        //Además, se guarda la ubicación en Ubicaciones
        if (pConcurrencia === false) {
            //resultado.mensaje ="Empezando";
            //Se obtienen los datos del plan de producción general
            var pproduccionGID = "";
            const pproduccionG = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { activo: { eq: true } }] });
            //Se actualiza el registro general de plan de producción.          
            if (pproduccionG.length > 0) {
                pproduccionGID = pproduccionG[0].id;
                var brecibaSerialIDS = pproduccionG[0].recibaSerialIDS ? pproduccionG[0].recibaSerialIDS : [];
                await Promise.all(pProduccionPintado.map(async (pproduccion) => {
                    const datoRepetido = brecibaSerialIDS[0] ? await brecibaSerialIDS.filter(datosPProduccion =>
                        datosPProduccion.includes(pproduccion.recibaSerialID)) : [];
                    if (!datoRepetido[0]) {
                        brecibaSerialIDS = brecibaSerialIDS[0] ?
                            [...brecibaSerialIDS, { id: pproduccion.recibaSerialID }] :
                            [{ id: pproduccion.recibaSerialID }];
                    }
                }));
                //Se guardan los datos del serial en el plan de producción general
                const rPProduccion = {
                    ...pproduccionG[0],
                    recibaSerialIDS: brecibaSerialIDS,
                    Reg_Mod_Usuario: userName
                };

                delete rPProduccion.createdAt;
                delete rPProduccion.updatedAt;
                delete rPProduccion.__typename;
                resultado.mensaje = "Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion);
                await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
            } else { //Si no existe, se crea el número de plan de producción en la tabla PProduccionUltimoNumero
                resultado.mensaje = "Obteniendo datos; 2";
                var numeroUP = 1;
                const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                    numeroUP = ultimaplaneacion.numero + 1;
                    ultimaplaneacion.numero = numeroUP;

                    delete ultimaplaneacion.createdAt;
                    delete ultimaplaneacion.updatedAt;
                    delete ultimaplaneacion.__typename;
                    ultimaplaneacion.Reg_Mod_Usuario = userName;
                    resultado.mensaje = "Problemas al actualizar updatePProduccionUltimoNumero";
                    await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                    return ultimaplaneacion;
                }))
                if (!ultimapFromAPI.length) {
                    await API.graphql({
                        query: createPProduccionUltimoNumero, variables: {
                            input: {
                                numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                            }
                        }
                    });
                }
                //Se crea el registro de la plan de producción general
                var brecibaSerialIDS = [];
                resultado.mensaje = "Obteniendo datos; 3";
                await Promise.all(pProduccionPintado.map(async (pproduccion) => {
                    const datoRepetido = brecibaSerialIDS[0] ? await brecibaSerialIDS.filter(datosPProduccion =>
                        datosPProduccion.includes(pproduccion.recibaSerialID)) : [];
                    if (!datoRepetido[0]) {
                        brecibaSerialIDS = brecibaSerialIDS[0] ?
                            [...brecibaSerialIDS, { id: pproduccion.recibaSerialID }] :
                            [{ id: pproduccion.recibaSerialID }];
                    }
                }));
                resultado.mensaje = "Problemas al guardar la planeación general 1 - Pintado";
                let resulppg = await API.graphql({
                    query: createPProduccionGeneral, variables: {
                        input: {
                            fechaDePlaneacion: fechaPlaneacion,
                            numero: numeroUP,
                            espacioVacio: 0,
                            porSerial: true,
                            recibaSerialIDS: brecibaSerialIDS,
                            activo: true,
                            Reg_Ins_Usuario: userName
                        }
                    }
                });
                pproduccionGID = resulppg.data.createPProduccionGeneral.id;
                resultado.pproduccionGID = pproduccionGID;
            }
            //Se determina el material que pasará de carga a pintado
            var registrosErr = 0;
            var concurrencias = "";
            var terminadoS = "";
            var terminadoyconcurrenciaS = "";
            var correctas = "";
            var fueradePlanta = "";
            var problemasUbicacion = "";
            await Promise.all(
                pProduccionPintado.map(async (pproduccion) => {
                    //Se obtiene el registro más reciente del serial en el plan de producción, para revisar
                    // concurrencia y el valor 
                    if (pproduccion.recibaSerialID) {
                        //Se obtienen los datos de reciba seriales por id
                        const recibaFromAPI = await GetRecibaSerialesID(pproduccion.recibaSerialID);
                        //Se asigna el valor de la fecha de la pintado
                        const fecha = Moment(new Date()).format("YYYY-MM-DD");
                        const hora = Moment(new Date()).format("HH:mm");
                        const fechahora = Moment(fecha + " " + hora).format("YYYY-MM-DD HH:mm");
                        const piezasEnCargando = (pproduccion.piezasenCargaPC ? pproduccion.piezasenCargaPC - (pproduccion.piezasenPintadoPC ? pproduccion.piezasenPintadoPC : 0) : 0);
                        //Se asigna el valor de la fecha de pintado
                        const piezasfechayhora = piezasEnCargando + " " + fechahora;
                        pproduccion.pintadoFechaHoraPC = !pproduccion.pintadoFechaHoraPC ?
                            piezasfechayhora : pproduccion.pintadoFechaHoraPC + ", " + piezasfechayhora;
                        if (recibaFromAPI.piezasEnPlanta === true) {
                            //Creación o actualización de registro en pProducción   
                            const datosPintado = {
                                produccionGID: pproduccionGID, fechaDePlaneacion: pproduccion.fechaDePlaneacion,
                                fecha: fecha, hora: hora, cantidadPiezas: pproduccion.cantidadPiezas,
                                piezasenPintado: piezasEnCargando, racks: pproduccion.racks,
                                ciclos: pproduccion.ciclos, Reg_Ins_Usuario: userName, modulo: moduloP
                            }
                            //Se actualizan los datos en recibaSeriales
                            resultado.mensaje = "Problemas al obtener los datos de ubicación";
                            if (recibaFromAPI.id) {
                                //Se cambia la ubicación del material de almacén a carga
                                const loacionAnterior = "Carga";
                                const ubicacionAnterior = "Producción-P";
                                const loacionPiezas = "Pintado";;
                                const ubicacionPiezas = "Producción-P";
                                const cantidadPiezas = piezasEnCargando;
                                var cambioUbicacionAux = [];
                                resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material 1";//"Antes de obtener los datos del cambio de ubicación";
                                cambioUbicacionAux = await cambioUbicacionSeriales(
                                    recibaFromAPI,
                                    ubicacionAnterior,
                                    loacionAnterior,
                                    ubicacionPiezas,
                                    loacionPiezas,
                                    cantidadPiezas);
                                resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material 2";//"Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAux);
                                if (cambioUbicacionAux.mensaje != "") {
                                    resultado.mensaje = cambioUbicacionAux.mensaje;
                                    resultado.color = cambioUbicacionAux.color;
                                    return resultado;
                                } else {
                                    recibaFromAPI.ultimaUbicacion = cambioUbicacionAux.sUltimaU;
                                    recibaFromAPI.rubicaciones = cambioUbicacionAux.sUbicaciones
                                    //resultado.mensaje = "Ubicaciones agrupadas";
                                }
                                const datosPintandor = recibaFromAPI.registroPintadoPC ? recibaFromAPI.registroPintadoPC : [];
                                await datosPintandor.push(datosPintado);

                                recibaFromAPI.registroPintadoPC = datosPintandor;
                                recibaFromAPI.pintadoFechaHoraPC = pproduccion.pintadoFechaHoraPC;
                                delete recibaFromAPI.createdAt;
                                delete recibaFromAPI.updatedAt;
                                delete recibaFromAPI.__typename;

                                delete recibaFromAPI.piezasCtnaRecuperadas;
                                delete recibaFromAPI.piezasInspeccion;
                                delete recibaFromAPI.piezasInspeccionPC;
                                delete recibaFromAPI.piezasIRecuperacion;
                                delete recibaFromAPI.piezasCRecuperacion;
                                delete recibaFromAPI.PiezasCtnaRecuperacion;
                                delete recibaFromAPI.piezasTRecuperacion;
                                delete recibaFromAPI.piezasRecuperadas;

                                recibaFromAPI.piezasenPintadoPC = recibaFromAPI.piezasenCargaPC;
                                recibaFromAPI.Reg_Mod_Usuario = userName;
                                resultado.mensaje = "Operación errónea; Problemas al guardar datos de seriales ";
                                let upRecibaS = await API.graphql({
                                    query: updateRecibaSeriales,
                                    variables: { input: recibaFromAPI },
                                });
                                //Se actualizan los datos en recibaSerialesMP
                                const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                                if (recibaFromAPI.recibaSerialMPID) {
                                    delete recibaFromAPI.recibaSerialMPID;
                                    resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI);
                                    await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                                }
                                //Se registra el dato de Resultado de operación
                                //pproduccion.piezasEnpintandoPC = piezasEnCargando;
                                //const rOperacion = await manageResumenOperacion(fecha, pproduccion, "Producción", userName, pproduccionGID);
                                //Liberar locación en caso de que la cantidad en pintado sea igual a la cantidad que se recibió.
                                //Obtener la cantidad que se recibió.
                                const cantidadRecibida = recibaFromAPI.cantidadRecibida;
                                //Revisar si la cantidad que se recibió es la misma de pintado
                                if (cantidadRecibida === pproduccion.piezasenPintado) {
                                    //Obtener el registro de la locación en ubicación que se tiene que liberar
                                    const ubicacionAlmacen = await cambioUbicacionAux.sUbicaciones
                                        .filter((ubicacion) => ubicacion.ubicacion === "Almacén")
                                        .sort((a, b) =>
                                            a.orden < b.orden ? 1 : a.orden > b.orden ? -1 : 0
                                        );
                                    //resultado.mensaje ="Obteniendo datos, Ubicación:" + JSON.stringify(ubicacionAlmacen);
                                    if (ubicacionAlmacen[0].locacion) {
                                        //const apiLocData = await API.graphql({ query: listLocacions, variables: { filter: filterl, limit: 100000000 } });
                                        const locacionSinfiltro = await GetLocaciones({
                                            locacion: { eq: ubicacionAlmacen[0].locacion },
                                        }); //.data.listLocacions.items;
                                        //resultado.mensaje ="Obteniendo datos, Locación: " + JSON.stringify(ubicacionAlmacen[0].locacion) + " Array: " +  JSON.stringify(locacionSinfiltro) ;
                                        //Liberar la locación
                                        if (locacionSinfiltro.length > 0)
                                            liberarlocacionb(
                                                locacionSinfiltro[0],
                                                ubicacionAlmacen[0].espacioOcupado,
                                                userName
                                            );
                                    }
                                }
                                correctas = (correctas === "" ? "" : correctas + ", ") + pproduccion.serialRecibaBTI
                            } else {
                                registrosErr++;
                                fueradePlanta = (fueradePlanta === "" ? "" : fueradePlanta + ", ") + pproduccion.serialRecibaBTI;
                            }
                        } else {
                            registrosErr++;
                            problemasUbicacion = (problemasUbicacion === "" ? "" : problemasUbicacion + ", ") + pproduccion.serialRecibaBTI;
                        }
                    }
                })
            );
            if (registrosErr === 0) {
                resultado.color = "primary";
                resultado.mensaje = "Operación exitosa";
                resultado.completo = true;
                return resultado;
            } else {
                resultado.mensaje = "Operación terminada;" + (correctas ? (" Operación exitosa para los seriales: " + correctas + ".") : "")
                    + (terminadoyconcurrenciaS ? (" No se pudo terminar la operación por concurrencia y finalización de plan de producción para: " + terminadoyconcurrenciaS + ".") : "")
                    + (concurrencias ? (" No se pudo terminar la operación por concurrencia para: " + concurrencias + ".") : "")

                    + (fueradePlanta ? (" No se pudo terminar la operación por que está marcado fuera de planta para: " + fueradePlanta + ".") : "")
                    + (problemasUbicacion ? (" No se pudo terminar la operación por problemas de ubicación para: " + problemasUbicacion + ".") : "")

                    + (terminadoS ? (" No se pudo terminar la operación por finalización de plan de producción para: " + terminadoS + ".") : "");
                resultado.color = "warning";
                return resultado;
            }
            //await fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
        } else {
            //Si  hay concurrencia se tienen que actualizar los datos
            window.scrollTo(0, 0);
            resultado.mensaje = "No fue posible realizar la operación: existe concurrencia, se actualizó la información, favor de revisar los datos y " +
                " volver a intentarlo";
            //fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
            return resultado;

        }
    } catch (e) {
        resultado.color = "warning";
        return resultado;
    }
}
//Registra los datos de Inspección del material
export async function guardarInspeccion(pInspeccion, userName, moduloI) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [], pproduccionGID: "" };
    try {//Revisa que no falten datos
        pInspeccion.cUnaInspeccion = true;
        const piezasTotales = ((parseInt(pInspeccion.piezasCalidad ? pInspeccion.piezasCalidad : 0) +
            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) +
            (parseInt(pInspeccion.piezasNoAceptadasOriginal ? pInspeccion.piezasNoAceptadasOriginal : 0))) +
            (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0)));

        const totalPiezasOperacion = (parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0) +
            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) +
            parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0));


        var mensaje = "";
        /*if (parseInt(piezasTotales) > parseInt(pInspeccion.piezasenPintado))
            mensaje = "La suma total de las piezas a embarcar y piezas en recuperación no debe ser mayor a " + pInspeccion.piezasenPintado + ".";*/

        //Validación de las piezas máximas si el material viene de pintado
        //if (pInspeccion.cUnaInspeccion === true) {
        const uIpiezasTotales = (parseInt(pInspeccion.piezasInspeccion ? pInspeccion.piezasInspeccion : 0) +
            parseInt(pInspeccion.piezasIRecuperacion ? pInspeccion.piezasIRecuperacion : 0)) +
            (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0) +
                parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0));

        if (parseInt(uIpiezasTotales) > parseInt(pInspeccion.piezasenPintado))
            mensaje = "La suma total de las piezas pintadas y piezas en recuperación no debe ser mayor a " + pInspeccion.piezasenPintado + ".";


        //}
        if (!pInspeccion.piezasEnInspeccionando && !pInspeccion.piezasEnRecuperando && !pInspeccion.piezasNoAceptadas)
            mensaje = mensaje + "\nSe debe ingresar una cantidad de piezas aceptadas, no aceptadas o para el área de recuperación.";


        if ((pInspeccion.piezasDisponibles ? pInspeccion.piezasDisponibles : 0) === 0 ||
            pInspeccion.piezasDisponibles < totalPiezasOperacion) {
            mensaje = "Operación denegada; se intenta ingresar una cantidad mayor de piezas a las piezas disponibles para esta operación. " +
                " Piezas disponibles: " + (pInspeccion.piezasDisponibles ? pInspeccion.piezasDisponibles : 0) + " Piezas en operación totales: " + totalPiezasOperacion;
        }
        if ((pInspeccion.piezasEnRecuperando && ((!pInspeccion.defecto || !pInspeccion.mRecuperacion) ||
            (pInspeccion.defecto === "Otro" && !pInspeccion.otroDefecto) || (pInspeccion.mRecuperacion === "Otro" &&
                !pInspeccion.otroMRecuperacion))) || (pInspeccion.piezasNoAceptadas && (!pInspeccion.pnadefecto) ||
                    (pInspeccion.pnadefecto === "Otro" && !pInspeccion.pnaotroDefecto)))
            mensaje = mensaje + "\nFaltan datos, los datos marcados con asterísco son obligatorios";

        if (mensaje !== "") {
            resultado.mensaje = mensaje;
            resultado.color = "warning"
            return resultado;
        } else {
            var pConcurrencia = false;
            //Se obtienen los datos del plan de producción por id para revisar la concurrencia                
            /*const dataFromAPI = await GetPProduccionID(pInspeccion.id);
            if (!dataFromAPI.id) {
                pConcurrencia = true;
                //setMensajeAlert("Menor que 1");  
            } else {
                if (dataFromAPI.updatedAt !== pInspeccion.updatedAt) {
                    pConcurrencia = true;
                    //setMensajeAlert("Diferente UpdateAt, Update tabla: " + dataFromAPI.updatedAt + " Update registro leido: "+ pInspeccion.updatedAt );  
                }
            }*/
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de piezasenCarga  en pProduccion
            //Además, se guarda la ubicación en Ubicaciones
            var auxUltimaUbicacion = [];
            if (pConcurrencia === false) {
                //Se guardan los registros en Plan de producción general
                var pproduccionGID = "";
                const fecha = Moment(new Date()).format("YYYY-MM-DD");
                resultado.mensaje = "Obteniendo datos; 1";
                const ppg = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fecha } }, { activo: { eq: true } }] });
                resultado.mensaje = "Obteniendo datos; 2";
                //Se actualiza el registro general de plan de producción.          
                if (ppg.length > 0) {
                    pproduccionGID = ppg[0].id;
                    const pproduccionG = ppg[0];
                    const datoRepetido = pproduccionG.recibaSerialIDS ? await pproduccionG.recibaSerialIDS.filter(datosPProduccion =>
                        datosPProduccion.includes(pInspeccion.recibaSerialID)) : [];
                    if (!datoRepetido[0]) {
                        const brecibaSerialIDS = pproduccionG.recibaSerialIDS ?
                            [...pproduccionG.recibaSerialIDS, { id: pInspeccion.recibaSerialID }] :
                            [{ id: pInspeccion.recibaSerialID }];

                        const rPProduccion = {
                            ...pproduccionG,
                            recibaSerialIDS: brecibaSerialIDS,
                            Reg_Mod_Usuario: userName
                        };

                        delete rPProduccion.createdAt;
                        delete rPProduccion.updatedAt;
                        delete rPProduccion.__typename;
                        resultado.mensaje = "Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion);
                        await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
                    }
                } else { //Si no existe, se crea el número de plan de producción en la tabla PProduccionUltimoNumero
                    resultado.mensaje = "Obteniendo datos; 3";
                    var numeroUP = 1;
                    const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                    const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                    await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                        numeroUP = ultimaplaneacion.numero + 1;
                        ultimaplaneacion.numero = numeroUP;

                        delete ultimaplaneacion.createdAt;
                        delete ultimaplaneacion.updatedAt;
                        delete ultimaplaneacion.__typename;
                        ultimaplaneacion.Reg_Mod_Usuario = userName;
                        await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                        return ultimaplaneacion;
                    }))
                    if (!ultimapFromAPI.length) {
                        await API.graphql({
                            query: createPProduccionUltimoNumero, variables: {
                                input: {
                                    numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                                }
                            }
                        });
                    }
                    //Se crea el registro de la plan de producción general
                    resultado.mensaje = "Problemas al guardar la planeación general 1 - Inspección";
                    let resulppg = await API.graphql({
                        query: createPProduccionGeneral, variables: {
                            input: {
                                fechaDePlaneacion: fecha,
                                numero: numeroUP,
                                espacioVacio: 0,
                                porSerial: true,
                                recibaSerialIDS: [{ id: pInspeccion.recibaSerialID }],
                                activo: true,
                                Reg_Ins_Usuario: userName
                            }
                        }
                    });
                    pproduccionGID = resulppg.data.createPProduccionGeneral.id;
                }
                //Se guardan los datos en RecibaSeriales                                     
                //Se obtiene el dato actual de reciba Seriales. 
                //Se asigna el valor de la fecha de la pintado
                const hora = Moment(new Date()).format("HH:mm");
                const fechahora = Moment(fecha + " " + hora).format("YYYY-MM-DD HH:mm");
                //Creación o actualización de registro en pProducción   
                const datosInspeccionF = {
                    produccionGID: pproduccionGID, fechaDePlaneacion: pInspeccion.fechaDePlaneacion, fecha: fecha,
                    hora: hora, cantidadPiezas: pInspeccion.cantidadPiezas, piezasAceptadas: pInspeccion.piezasEnInspeccionando,
                    piezasNoAceptadas: pInspeccion.piezasNoAceptadas, defecto: pInspeccion.pnadefecto,
                    pnaotroDefecto: pInspeccion.pnaotroDefecto, comentariosInspeccion: pInspeccion.comentariosInspeccion,
                    racks: pInspeccion.racks, ciclos: pInspeccion.ciclos, Reg_Ins_Usuario: userName,
                    numeroRackCarga: pInspeccion.numeroRackCarga, modulo: moduloI
                }
                const recibaFromAPI = await GetRecibaSerialesID(pInspeccion.recibaSerialID);
                if (recibaFromAPI.id) {
                    //Se valida si el material ya no está en planta
                    if (recibaFromAPI.piezasEnPlanta === false) {
                        resultado.mensaje = "Operación denegada; El material ya fue marcado fuera de planta";
                        resultado.color = "warning";
                        return resultado;
                    }
                    //Se valida si el material ya está marcado en inspección final
                    if (recibaFromAPI.cantidadPlaneada <= recibaFromAPI.piezasCalidad) {
                        resultado.mensaje = "Operación denegada; El material ya se registró como liberado por calidad";
                        resultado.color = "warning";
                        return resultado;
                    }
                    var piezasCalidad = parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0) +
                        parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0);
                    var piezasNoAceptadas = parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                    if (piezasNoAceptadas > 0) {
                        const loacionPiezas = "";
                        const ubicacionPiezas = "Cuarentena";
                        const loacionAnterior = "Pintado"; //pInspeccion.cUnaInspeccion === false ? "Inspección" : "Pintado";
                        const ubicacionAnterior = "Producción";
                        const cantidadPiezas = piezasNoAceptadas;
                        auxUltimaUbicacion = await cambioUbicacionSeriales(recibaFromAPI, ubicacionAnterior, loacionAnterior, ubicacionPiezas, loacionPiezas, cantidadPiezas);

                        resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material 3 " + JSON.stringify(auxUltimaUbicacion); //"Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion);
                        if (auxUltimaUbicacion.mensaje != "") {
                            resultado.mensaje = auxUltimaUbicacion.mensaje;
                            resultado.color = auxUltimaUbicacion.color;
                            return resultado;
                        } else {
                            recibaFromAPI.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibaFromAPI.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            resultado.mensaje = "Ubicaciones agrupadas (1)" + JSON.stringify(auxUltimaUbicacion);
                        }


                    }
                    if (piezasCalidad > 0) {
                        const loacionPiezas = "Calidad";
                        const ubicacionPiezas = "Producción";
                        const loacionAnterior = "Pintado";//pInspeccion.cUnaInspeccion === false ? "Inspección" : "Pintado";
                        const ubicacionAnterior = "Producción";
                        const cantidadPiezas = piezasCalidad;
                        const json = piezasNoAceptadas > 0 ? true : false;
                        resultado.mensaje = "Piezas en calidad (1)" + JSON.stringify(recibaFromAPI.rubicaciones);
                        auxUltimaUbicacion = await cambioUbicacionSeriales(recibaFromAPI, ubicacionAnterior, loacionAnterior, ubicacionPiezas, loacionPiezas, cantidadPiezas, json);
                        resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material4";//"Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion);
                        if (auxUltimaUbicacion.mensaje != "") {
                            resultado.mensaje = auxUltimaUbicacion.mensaje;
                            resultado.color = auxUltimaUbicacion.color;
                            return resultado;
                        } else {
                            recibaFromAPI.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibaFromAPI.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            resultado.mensaje = "Ubicaciones agrupadas (2)";
                        }
                    }
                    delete recibaFromAPI.createdAt;
                    delete recibaFromAPI.updatedAt;
                    delete recibaFromAPI.__typename;

                    if (pInspeccion.piezasEnInspeccionando) {
                        const piezasfechayhora = pInspeccion.piezasEnInspeccionando + " " + fechahora;
                        recibaFromAPI.calidadFechaHora = !recibaFromAPI.calidadFechaHora ?
                            piezasfechayhora : recibaFromAPI.calidadFechaHora + ", " + piezasfechayhora;

                        recibaFromAPI.piezasCalidad = !recibaFromAPI.piezasCalidad ? (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0)) :
                            parseInt(recibaFromAPI.piezasCalidad) + (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0));

                        recibaFromAPI.piezasPintadas = !recibaFromAPI.piezasPintadas ? (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0)) :
                            parseInt(recibaFromAPI.piezasPintadas) + (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0));
                    }
                    //Indicador de única inspección.
                    recibaFromAPI.cUnaInspeccion = true// pInspeccion.cUnaInspeccion;

                    //if ((recibaFromAPI.Pcoat ? recibaFromAPI.Pcoat : false) === false) {
                    recibaFromAPI.piezasAEmbarcar = !recibaFromAPI.piezasAEmbarcar ?
                        ((recibaFromAPI.Pcoat ? recibaFromAPI.Pcoat : false) === false ?
                            parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0) : 0 +
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0)) :
                        parseInt(recibaFromAPI.piezasAEmbarcar) +
                        ((recibaFromAPI.Pcoat ? recibaFromAPI.Pcoat : false) === false ?
                            parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0) : 0 +
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0));
                    //}

                    if (parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) > 0) {
                        const piezasfechayhora = pInspeccion.piezasNoAceptadas + " " + fechahora;
                        recibaFromAPI.noAceptadasFechaHora = !recibaFromAPI.noAceptadasFechaHora ?
                            piezasfechayhora : recibaFromAPI.noAceptadasFechaHora + ", " + piezasfechayhora;

                        recibaFromAPI.piezasNoAceptadas = recibaFromAPI.piezasNoAceptadas ?
                            (recibaFromAPI.piezasNoAceptadas + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0)) :
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                        recibaFromAPI.piezasNRecuperadas = !recibaFromAPI.piezasNRecuperadas ?
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) :
                            recibaFromAPI.piezasNRecuperadas + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                        recibaFromAPI.piezasenCuarentena = !recibaFromAPI.piezasenCuarentena ?
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) :
                            recibaFromAPI.piezasenCuarentena + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                        recibaFromAPI.piezasCtnaPintadas = !recibaFromAPI.piezasCtnaPintadas ?
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) :
                            parseInt(recibaFromAPI.piezasCtnaPintadas) + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                    } else {
                        delete pInspeccion.piezasNoAceptadas;
                    }


                    if (pInspeccion.piezasEnRecuperando) {
                        recibaFromAPI.piezasCRecuperacion = !recibaFromAPI.piezasCRecuperacion ? parseInt(pInspeccion.piezasEnRecuperando) :
                            parseInt(recibaFromAPI.piezasCRecuperacion) + parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0);

                        recibaFromAPI.piezasTRecuperacion = !recibaFromAPI.piezasTRecuperacion ? parseInt(pInspeccion.piezasEnRecuperando) :
                            parseInt(recibaFromAPI.piezasTRecuperacion) + parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0);
                    }
                    const datosInspeccionFR = recibaFromAPI.registroInspeccionF ? recibaFromAPI.registroInspeccionF : [];
                    await datosInspeccionFR.push(datosInspeccionF);
                    recibaFromAPI.registroInspeccionF = datosInspeccionFR;

                    if (!recibaFromAPI.piezasCtnaRecuperadas) { delete recibaFromAPI.piezasCtnaRecuperadas; };
                    if (!recibaFromAPI.piezasInspeccion) { delete recibaFromAPI.piezasInspeccion; };
                    if (!delete recibaFromAPI.piezasInspeccionPC) { delete recibaFromAPI.piezasInspeccionPC; };
                    if (!recibaFromAPI.piezasIRecuperacion) { delete recibaFromAPI.piezasIRecuperacion; };
                    if (!recibaFromAPI.piezasCRecuperacion) { delete recibaFromAPI.piezasCRecuperacion; };
                    if (!recibaFromAPI.PiezasCtnaRecuperacion) { delete recibaFromAPI.PiezasCtnaRecuperacion; };
                    if (!delete recibaFromAPI.piezasTRecuperacion) { delete recibaFromAPI.piezasTRecuperacion; };
                    if (!delete recibaFromAPI.piezasRecuperadas) { delete recibaFromAPI.piezasRecuperadas; };
                    if (!delete recibaFromAPI.piezasCtnaNRecuperadas) { delete recibaFromAPI.piezasCtnaNRecuperadas; };

                    recibaFromAPI.Reg_Mod_Usuario = userName;
                    resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial 1" + JSON.stringify(recibaFromAPI);
                    let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaFromAPI } });
                    //Se actualizan los datos en recibaSerialesMP
                    const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                    if (recibaFromAPI.recibaSerialMPID) {
                        delete recibaFromAPI.recibaSerialMPID;
                        resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial 2" + JSON.stringify(recibaFromAPI);
                        await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                    }
                }

                //Sí hay material para recuperación, se registra en la tabla de recuperación.
                /*if (pInspeccion.piezasEnRecuperando > 0) {
                    const Recuperacion = {};

                    Recuperacion.recibaSerialID = pInspeccion.recibaSerialID;
                    Recuperacion.pProduccionID = pInspeccion.id;
                    Recuperacion.clienteID = pInspeccion.clienteID;
                    Recuperacion.cliente = pInspeccion.cliente;
                    Recuperacion.productoID = pInspeccion.productoID;
                    Recuperacion.numerodeParte = pInspeccion.numerodeParte;
                    Recuperacion.descripcion = pInspeccion.descripcion;
                    Recuperacion.serial = pInspeccion.serial;
                    Recuperacion.serialRecibaBTI = pInspeccion.serialRecibaBTI;
                    Recuperacion.cantidad = pInspeccion.piezasEnRecuperando;

                    Recuperacion.ingresadoPorArea = "Producción Calidad";
                    Recuperacion.UbicacionDeIngreso = "Producción";
                    Recuperacion.LocacionDeIngreso = "Calidad";
                    Recuperacion.ingresadoPorUsuario = userName;
                    //Recuperacion.mesaInspeccion = pInspeccion.mesaInspeccion;
                    Recuperacion.defecto = pInspeccion.defecto;
                    Recuperacion.otroDefecto = pInspeccion.otroDefecto;
                    Recuperacion.mRecuperacion = pInspeccion.mRecuperacion;
                    Recuperacion.otroMRecuperacion = pInspeccion.otroMRecuperacion;
                    Recuperacion.comentariosInspeccion = pInspeccion.comentariosInspeccion;
                    Recuperacion.activo = true;
                    Recuperacion.fechaIngreso = fecha;
                    Recuperacion.horaIngreso = hora;
                    Recuperacion.Reg_Ins_Usuario = userName;
                    resultado.mensaje = "Operación errónea; Problemas al guardar los datos del material en recuperación" + JSON.stringify(Recuperacion);
                    await API.graphql({ query: createRecuperacion, variables: { input: Recuperacion } });

                }*/
                const rOperacion = await manageResumenOperacion(fecha, pInspeccion, "InspeccionF", userName, pproduccionGID);

                resultado.mensaje = "Operación exitosa"; //, piezas totales: " + piezasTotales + ", piezas en pintado: " + pInspeccion.piezasenPintado
                resultado.color = "primary";
                resultado.completo = true;
                return resultado;
            } else { //Si  hay concurrencia se tienen que actualizar los datos
                resultado.mensaje = "No fue posible realizar la operación: existe concurrencia, favor de recargar los datos y " +
                    " volver a intentarlo";
                resultado.color = "warning";
                return resultado;
            }
        }
    } catch (e) {
        //resultado.mensaje ="No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas";
        resultado.color = "warning";
        return resultado;
    }

};
export async function guardarInspeccionPC(pInspeccion, userName, moduloI) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [], pproduccionGID: "" };
    try {//Revisa que no falten datos

        const piezasTotales = ((parseInt(pInspeccion.piezasCalidadPC ? pInspeccion.piezasCalidadPC : 0) +
            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) +
            (parseInt(pInspeccion.piezasNoAceptadasOriginal ? pInspeccion.piezasNoAceptadasOriginal : 0))) +
            (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0)));

        const totalPiezasOperacion = (parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) +
            parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0));


        var mensaje = "";
        /*if (parseInt(piezasTotales) > parseInt(pInspeccion.piezasenPintado))
            mensaje = "La suma total de las piezas a embarcar y piezas en recuperación no debe ser mayor a " + pInspeccion.piezasenPintado + ".";*/

        //Validación de las piezas máximas si el material viene de pintado

        const uIpiezasTotales = (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0));

        if (parseInt(uIpiezasTotales) > parseInt(pInspeccion.piezasenPintado))
            mensaje = "La suma total de las piezas pintadas y piezas en recuperación no debe ser mayor a " + pInspeccion.piezasenPintado + ".";


        if (!pInspeccion.piezasEnInspeccionando && !pInspeccion.piezasNoAceptadas)
            mensaje = mensaje + "\nSe debe ingresar una cantidad de piezas aceptadas ó piezas no aceptadas";


        if ((pInspeccion.piezasDisponibles ? pInspeccion.piezasDisponibles : 0) === 0 ||
            pInspeccion.piezasDisponibles < totalPiezasOperacion) {
            mensaje = "Operación denegada; se intenta ingresar una cantidad mayor de piezas a las piezas disponibles para esta operación. " +
                " Piezas disponibles: " + (pInspeccion.piezasDisponibles ? pInspeccion.piezasDisponibles : 0) + " Piezas en operación totales: " + totalPiezasOperacion;
        }
        if ((pInspeccion.piezasEnRecuperando && ((!pInspeccion.defecto || !pInspeccion.mRecuperacion) ||
            (pInspeccion.defecto === "Otro" && !pInspeccion.otroDefecto) || (pInspeccion.mRecuperacion === "Otro" &&
                !pInspeccion.otroMRecuperacion))) || (pInspeccion.piezasNoAceptadas && (!pInspeccion.pnadefecto) ||
                    (pInspeccion.pnadefecto === "Otro" && !pInspeccion.pnaotroDefecto)))
            mensaje = mensaje + "\nFaltan datos, los datos marcados con asterísco son obligatorios";

        if (mensaje !== "") {
            resultado.mensaje = mensaje;
            resultado.color = "warning"
            return resultado;
        } else {
            var pConcurrencia = false;
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de piezasenCarga  en pProduccion
            //Además, se guarda la ubicación en Ubicaciones
            var auxUltimaUbicacion = [];
            if (pConcurrencia === false) {
                //Se guardan los registros en Plan de producción general
                var pproduccionGID = "";
                const fecha = Moment(new Date()).format("YYYY-MM-DD");
                resultado.mensaje = "Obteniendo datos; 1";
                const ppg = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fecha } }, { activo: { eq: true } }] });
                resultado.mensaje = "Obteniendo datos; 2";
                //Se actualiza el registro general de plan de producción.          
                if (ppg.length > 0) {
                    pproduccionGID = ppg[0].id;
                    const pproduccionG = ppg[0];
                    const datoRepetido = pproduccionG.recibaSerialIDS ? await pproduccionG.recibaSerialIDS.filter(datosPProduccion =>
                        datosPProduccion.includes(pInspeccion.recibaSerialID)) : [];
                    if (!datoRepetido[0]) {
                        const brecibaSerialIDS = pproduccionG.recibaSerialIDS ?
                            [...pproduccionG.recibaSerialIDS, { id: pInspeccion.recibaSerialID }] :
                            [{ id: pInspeccion.recibaSerialID }];

                        const rPProduccion = {
                            ...pproduccionG,
                            recibaSerialIDS: brecibaSerialIDS,
                            Reg_Mod_Usuario: userName
                        };

                        delete rPProduccion.createdAt;
                        delete rPProduccion.updatedAt;
                        delete rPProduccion.__typename;
                        resultado.mensaje = "Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion);
                        await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
                    }
                } else { //Si no existe, se crea el número de plan de producción en la tabla PProduccionUltimoNumero
                    resultado.mensaje = "Obteniendo datos; 3";
                    var numeroUP = 1;
                    const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                    const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                    await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                        numeroUP = ultimaplaneacion.numero + 1;
                        ultimaplaneacion.numero = numeroUP;

                        delete ultimaplaneacion.createdAt;
                        delete ultimaplaneacion.updatedAt;
                        delete ultimaplaneacion.__typename;
                        ultimaplaneacion.Reg_Mod_Usuario = userName;
                        await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                        return ultimaplaneacion;
                    }))
                    if (!ultimapFromAPI.length) {
                        await API.graphql({
                            query: createPProduccionUltimoNumero, variables: {
                                input: {
                                    numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                                }
                            }
                        });
                    }
                    //Se crea el registro de la plan de producción general
                    resultado.mensaje = "Problemas al guardar la planeación general 1 - Inspección";
                    let resulppg = await API.graphql({
                        query: createPProduccionGeneral, variables: {
                            input: {
                                fechaDePlaneacion: fecha,
                                numero: numeroUP,
                                espacioVacio: 0,
                                porSerial: true,
                                recibaSerialIDS: [{ id: pInspeccion.recibaSerialID }],
                                activo: true,
                                Reg_Ins_Usuario: userName
                            }
                        }
                    });
                    pproduccionGID = resulppg.data.createPProduccionGeneral.id;
                }
                //Se guardan los datos en RecibaSeriales                                     
                //Se obtiene el dato actual de reciba Seriales. 
                //Se asigna el valor de la fecha de la pintado
                const hora = Moment(new Date()).format("HH:mm");
                const fechahora = Moment(fecha + " " + hora).format("YYYY-MM-DD HH:mm");
                //Creación o actualización de registro en pProducción  
                resultado.mensaje = "Operación denegada; Revisando datos Inspección5";
                const datosInspeccionF = {
                    produccionGID: pproduccionGID, fechaDePlaneacion: pInspeccion.fechaDePlaneacion, fecha: fecha,
                    hora: hora, cantidadPiezas: pInspeccion.cantidadPiezas, piezasAceptadas: pInspeccion.piezasEnInspeccionando,
                    piezasNoAceptadas: pInspeccion.piezasNoAceptadas, defecto: pInspeccion.pnadefecto,
                    pnaotroDefecto: pInspeccion.pnaotroDefecto, comentariosInspeccion: pInspeccion.comentariosInspeccion,
                    racks: pInspeccion.racks, ciclos: pInspeccion.ciclos, Reg_Ins_Usuario: userName,
                    numeroRackCarga: pInspeccion.numeroRackCarga, modulo: moduloI
                }
                resultado.mensaje = "Operación denegada; Revisando datos Inspección6: " + JSON.stringify(pInspeccion);
                const recibaFromAPI = await GetRecibaSerialesID(pInspeccion.recibaSerialID);
                resultado.mensaje = "Operación denegada; Revisando datos Inspección7";
                if (recibaFromAPI.id) {
                    //Se valida si el material ya no está en planta
                    if (recibaFromAPI.piezasEnPlanta === false) {
                        resultado.mensaje = "Operación denegada; El material ya fue marcado fuera de planta";
                        resultado.color = "warning";
                        return resultado;
                    }
                    //Se valida si el material ya está marcado en inspección final
                    if (recibaFromAPI.cantidadPlaneadaPC <= recibaFromAPI.piezasCalidadPC) {
                        resultado.mensaje = "Operación denegada; El material ya se registró como liberado por calidad";
                        resultado.color = "warning";
                        return resultado;
                    }
                    var piezasCalidad = parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0);
                    var piezasNoAceptadas = parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                    if (piezasNoAceptadas > 0) {
                        const loacionPiezas = "";
                        const ubicacionPiezas = "Cuarentena";
                        const loacionAnterior = "Pintado";
                        const ubicacionAnterior = "Producción-P";
                        const cantidadPiezas = piezasNoAceptadas;
                        auxUltimaUbicacion = await cambioUbicacionSeriales(recibaFromAPI, ubicacionAnterior, loacionAnterior, ubicacionPiezas, loacionPiezas, cantidadPiezas);

                        resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material 3 " + JSON.stringify(auxUltimaUbicacion); //"Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion);
                        if (auxUltimaUbicacion.mensaje != "") {
                            resultado.mensaje = auxUltimaUbicacion.mensaje;
                            resultado.color = auxUltimaUbicacion.color;
                            return resultado;
                        } else {
                            recibaFromAPI.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibaFromAPI.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            resultado.mensaje = "Ubicaciones agrupadas (1)" + JSON.stringify(auxUltimaUbicacion);
                        }


                    }
                    if (piezasCalidad > 0) {
                        const loacionPiezas = "Calidad";
                        const ubicacionPiezas = "Producción-P";
                        const loacionAnterior = "Pintado";
                        const ubicacionAnterior = "Producción-P";
                        const cantidadPiezas = piezasCalidad;
                        const json = piezasNoAceptadas > 0 ? true : false;
                        resultado.mensaje = "Piezas en calidad (1)" + JSON.stringify(recibaFromAPI.rubicaciones);
                        auxUltimaUbicacion = await cambioUbicacionSeriales(recibaFromAPI, ubicacionAnterior, loacionAnterior, ubicacionPiezas, loacionPiezas, cantidadPiezas, json);
                        resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material4";//"Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion);
                        if (auxUltimaUbicacion.mensaje != "") {
                            resultado.mensaje = auxUltimaUbicacion.mensaje;
                            resultado.color = auxUltimaUbicacion.color;
                            return resultado;
                        } else {
                            recibaFromAPI.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibaFromAPI.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            resultado.mensaje = "Ubicaciones agrupadas (2)";
                        }
                    }
                    delete recibaFromAPI.createdAt;
                    delete recibaFromAPI.updatedAt;
                    delete recibaFromAPI.__typename;

                    if (pInspeccion.piezasEnInspeccionando) {
                        const piezasfechayhora = pInspeccion.piezasEnInspeccionando + " " + fechahora;
                        recibaFromAPI.calidadFechaHoraPC = !recibaFromAPI.calidadFechaHoraPC ?
                            piezasfechayhora : recibaFromAPI.calidadFechaHoraPC + ", " + piezasfechayhora;

                        recibaFromAPI.piezasCalidadPC = !recibaFromAPI.piezasCalidadPC ? (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0)) :
                            parseInt(recibaFromAPI.piezasCalidadPC) + (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0));

                        recibaFromAPI.piezasPintadasPC = !recibaFromAPI.piezasPintadasPC ? (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0)) :
                            parseInt(recibaFromAPI.piezasPintadasPC) + (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0));
                    }
                    //Indicador de única inspección.


                    recibaFromAPI.piezasAEmbarcar = !recibaFromAPI.piezasAEmbarcar ?
                        (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0) +
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0)) :
                        parseInt(recibaFromAPI.piezasAEmbarcar) +
                        (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0) +
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0));


                    if (parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) > 0) {
                        const piezasfechayhora = pInspeccion.piezasNoAceptadas + " " + fechahora;
                        recibaFromAPI.noAceptadasFechaHoraPC = !recibaFromAPI.noAceptadasFechaHoraPC ?
                            piezasfechayhora : recibaFromAPI.noAceptadasFechaHoraPC + ", " + piezasfechayhora;

                        recibaFromAPI.piezasNoAceptadasPC = recibaFromAPI.piezasNoAceptadasPC ?
                            (recibaFromAPI.piezasNoAceptadasPC + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0)) :
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                        recibaFromAPI.piezasNRecuperadasPC = !recibaFromAPI.piezasNRecuperadasPC ?
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) :
                            recibaFromAPI.piezasNRecuperadasPC + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                        recibaFromAPI.piezasenCuarentena = !recibaFromAPI.piezasenCuarentena ?
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) :
                            recibaFromAPI.piezasenCuarentena + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                        recibaFromAPI.piezasCtnaPintadasPC = !recibaFromAPI.piezasCtnaPintadasPC ?
                            parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) :
                            parseInt(recibaFromAPI.piezasCtnaPintadasPC) + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0);
                    } else {
                        delete pInspeccion.piezasNoAceptadas;
                    }

                    const datosInspeccionFR = recibaFromAPI.registroInspeccionFPC ? recibaFromAPI.registroInspeccionFPC : [];
                    await datosInspeccionFR.push(datosInspeccionF);
                    recibaFromAPI.registroInspeccionFPC = datosInspeccionFR;

                    if (!recibaFromAPI.piezasCtnaRecuperadas) { delete recibaFromAPI.piezasCtnaRecuperadas; };
                    if (!recibaFromAPI.piezasInspeccion) { delete recibaFromAPI.piezasInspeccion; };
                    if (!delete recibaFromAPI.piezasInspeccionPC) { delete recibaFromAPI.piezasInspeccionPC; };
                    if (!recibaFromAPI.piezasIRecuperacion) { delete recibaFromAPI.piezasIRecuperacion; };
                    if (!recibaFromAPI.piezasCRecuperacion) { delete recibaFromAPI.piezasCRecuperacion; };
                    if (!recibaFromAPI.PiezasCtnaRecuperacion) { delete recibaFromAPI.PiezasCtnaRecuperacion; };
                    if (!delete recibaFromAPI.piezasTRecuperacion) { delete recibaFromAPI.piezasTRecuperacion; };
                    if (!delete recibaFromAPI.piezasRecuperadas) { delete recibaFromAPI.piezasRecuperadas; };
                    if (!delete recibaFromAPI.piezasCtnaNRecuperadas) { delete recibaFromAPI.piezasCtnaNRecuperadas; };

                    recibaFromAPI.Reg_Mod_Usuario = userName;
                    resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI);
                    let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaFromAPI } });
                    //Se actualizan los datos en recibaSerialesMP
                    const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                    if (recibaFromAPI.recibaSerialMPID) {
                        delete recibaFromAPI.recibaSerialMPID;
                        resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI);
                        await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                    }
                }
                //Sí hay material para recuperación, se registra en la tabla de recuperación.
                /*if (pInspeccion.piezasEnRecuperando > 0) {
                    const Recuperacion = {};

                    Recuperacion.recibaSerialID = pInspeccion.recibaSerialID;
                    Recuperacion.pProduccionID = pInspeccion.id;
                    Recuperacion.clienteID = pInspeccion.clienteID;
                    Recuperacion.cliente = pInspeccion.cliente;
                    Recuperacion.productoID = pInspeccion.productoID;
                    Recuperacion.numerodeParte = pInspeccion.numerodeParte;
                    Recuperacion.descripcion = pInspeccion.descripcion;
                    Recuperacion.serial = pInspeccion.serial;
                    Recuperacion.serialRecibaBTI = pInspeccion.serialRecibaBTI;
                    Recuperacion.cantidad = pInspeccion.piezasEnRecuperando;

                    Recuperacion.ingresadoPorArea = "Producción-P Calidad";
                    Recuperacion.UbicacionDeIngreso = "Producción-P";
                    Recuperacion.LocacionDeIngreso = "Calidad";
                    Recuperacion.ingresadoPorUsuario = userName;
                    //Recuperacion.mesaInspeccion = pInspeccion.mesaInspeccion;
                    Recuperacion.defecto = pInspeccion.defecto;
                    Recuperacion.otroDefecto = pInspeccion.otroDefecto;
                    Recuperacion.mRecuperacion = pInspeccion.mRecuperacion;
                    Recuperacion.otroMRecuperacion = pInspeccion.otroMRecuperacion;
                    Recuperacion.comentariosInspeccion = pInspeccion.comentariosInspeccion;
                    Recuperacion.activo = true;
                    Recuperacion.fechaIngreso = fecha;
                    Recuperacion.horaIngreso = hora;
                    Recuperacion.Reg_Ins_Usuario = userName;
                    resultado.mensaje = "Operación errónea; Problemas al guardar los datos del material en recuperación" + JSON.stringify(Recuperacion);
                    await API.graphql({ query: createRecuperacion, variables: { input: Recuperacion } });

                }*/
                //const rOperacion = await manageResumenOperacion(fecha, pInspeccion, "InspeccionF", userName, pproduccionGID);

                resultado.mensaje = "Operación exitosa"; //, piezas totales: " + piezasTotales + ", piezas en pintado: " + pInspeccion.piezasenPintado
                resultado.color = "primary";
                resultado.completo = true;
                return resultado;
            } else { //Si  hay concurrencia se tienen que actualizar los datos
                resultado.mensaje = "No fue posible realizar la operación: existe concurrencia, favor de recargar los datos y " +
                    " volver a intentarlo";
                resultado.color = "warning";
                return resultado;
            }
        }
    } catch (e) {
        //resultado.mensaje ="No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas";
        resultado.color = "warning";
        return resultado;
    }

};
//Registra los datos de carga y de pintado(solo cuando es necesario) del material.
export async function guardarCargaPintado(registroNuevoPP, userName, moduloCP, idProduccionGeneral, sporNPU, recibaOriginal) {
    // toggle();
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [], pproduccionGID: "" };
    //subscriptions.unsubscribe();
    try {
        if (!registroNuevoPP.productoID || !registroNuevoPP.cliente || !registroNuevoPP.numerodeParte ||
            !registroNuevoPP.cantidadPiezas || !registroNuevoPP.racks || !registroNuevoPP.ciclos ||
            !registroNuevoPP.fechaDePlaneacion || registroNuevoPP.cantidadDisponible < registroNuevoPP.cantidadPiezas ||
            !registroNuevoPP.cicloCarga || registroNuevoPP.cantidadDisponible < (sporNPU === false ? registroNuevoPP.cantidadPiezasCargando :
                registroNuevoPP.cantidadDisponible) || (registroNuevoPP.cantidadPiezasCargando > registroNuevoPP.cantidadPiezas && sporNPU === false) ||
            (sporNPU === false && (!registroNuevoPP.cantidadPiezasCargando || !registroNuevoPP.rackCarga))) {
            resultado.mensaje = "Faltan datos o son erróneos: los campos marcados con un asterisco son obligatorios," +
                " la cantidad del material agregado no pude ser mayor a la cantidad disponible ni a la cantidad planeada, se marcan en rojo los datos erróneos.";
            resultado.color = "warning";
        } else {
            //Variables auxiliares
            var numeroUP = 1;
            var pConcurrencia = false;
            const fechaPlaneacion = registroNuevoPP.fechaDePlaneacion;
            var pproduccionGID = {};
            var pproduccionIDS = [];
            var rSerialesIDS = [];
            //Se revisa la concurrencia en recibaSeriales si se trata de agregado individual (manual)
            if (sporNPU === false) {
                //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca activo igual a falso  en planeaciones
                const recibaDatosA = await GetRecibaSerialesID(recibaOriginal.id);
                if (!recibaDatosA.id) {//Si no se obtuvieron datos, se determina que hay concurrencia
                    pConcurrencia = true;
                } else if (recibaDatosA.cantidadPlaneada != recibaOriginal.cantidadPlaneada) {//Si la cantidad planeada se modificó, se marca como concurrencia
                    pConcurrencia = true;
                }
            }
            if (pConcurrencia === false) {
                //Se obtienen los planes de producción con la fecha del plan de producción en cuestión.                
                resultado.mensaje = "Obteniendo datos; 1";
                var pproduccionF = {};
                if (idProduccionGeneral) {
                    resultado.mensaje = "Obteniendo datos; 1-1";
                    const ppg = await GetPProduccionGeneralID(idProduccionGeneral);
                    if (ppg.id) {
                        pproduccionF = ppg;
                    }
                } else {
                    resultado.mensaje = "Obteniendo datos; 1-2";
                    const ppg = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { activo: { eq: true } }] });
                    if (ppg.length > 0) {
                        pproduccionF = ppg[0];
                    }
                    resultado.mensaje = "Obteniendo datos; 1-3";
                }
                //resultado.mensaje = "Obteniendo datos; Aquí";
                //return;
                //Si es una inserción, se obtiene el número que le corresponde        
                //Se revisa si ya existe un plan de producción con la fecha de hoy
                if (pproduccionF.id) { //Si existe el plan de producción, se obtiene el número de plan de producción y se agrega el id del serial .
                    numeroUP = pproduccionF.numero;
                    pproduccionGID = pproduccionF;
                    //Se actualiza el registro general de plan de producción.          
                    if (pproduccionGID.id) {
                        const pproduccionG = pproduccionF;
                        const datoRepetido = pproduccionG.recibaSerialIDS ? await pproduccionG.recibaSerialIDS.filter(datosPProduccion =>
                            datosPProduccion.includes(registroNuevoPP.recibaSerialID)) : [];
                        if (!datoRepetido[0]) {
                            const brecibaSerialIDS = pproduccionG.recibaSerialIDS ?
                                [...pproduccionG.recibaSerialIDS, { id: registroNuevoPP.recibaSerialID }] :
                                [{ id: registroNuevoPP.recibaSerialID }];

                            const rPProduccion = {
                                ...pproduccionG,
                                recibaSerialIDS: brecibaSerialIDS,
                                Reg_Mod_Usuario: userName
                            };

                            delete rPProduccion.createdAt;
                            delete rPProduccion.updatedAt;
                            delete rPProduccion.__typename;
                            resultado.mensaje = "Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion);
                            await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
                        }
                    }
                } else { //Si no existe, se crea el número de plan de producción en la tabla PProduccionUltimoNumero
                    resultado.mensaje = "Obteniendo datos; 2";
                    const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                    const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                    await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                        numeroUP = ultimaplaneacion.numero + 1;
                        ultimaplaneacion.numero = numeroUP;

                        delete ultimaplaneacion.createdAt;
                        delete ultimaplaneacion.updatedAt;
                        delete ultimaplaneacion.__typename;
                        ultimaplaneacion.Reg_Mod_Usuario = userName;
                        await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                        return ultimaplaneacion;
                    }))
                    if (!ultimapFromAPI.length) {
                        await API.graphql({
                            query: createPProduccionUltimoNumero, variables: {
                                input: {
                                    numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                                }
                            }
                        });
                    }
                    //Se crea el registro de la plan de producción general
                    resultado.mensaje = "Problemas al guardar la planeación general 1-CP";
                    let resulppg = await API.graphql({
                        query: createPProduccionGeneral, variables: {
                            input: {
                                fechaDePlaneacion: fechaPlaneacion,
                                numero: numeroUP,
                                espacioVacio: 0,
                                porSerial: true,
                                recibaSerialIDS: [{ id: registroNuevoPP.recibaSerialID }],
                                activo: true,
                                Reg_Ins_Usuario: userName
                            }
                        }
                    });
                    pproduccionGID = resulppg.data.createPProduccionGeneral;
                }

                //_________________________________________________________________
                //Se inician los trabajos en planeación, plan de producción y RecibaSeriales
                resultado.mensaje = "Revisando reciba; 1";
                var datosPPS = [];
                var productosID = {};
                var cantidadPPS = parseFloat(registroNuevoPP.cantidadPiezas);
                const racksXPiezas = parseFloat(registroNuevoPP.racks) / parseFloat(registroNuevoPP.cantidadPiezas);
                resultado.mensaje = "Revisando reciba; 2";

                //Se revisa si la cantidad cantidadPPS es menor que 0
                if (cantidadPPS > 0) {
                    resultado.mensaje = "Revisando reciba; 3" + JSON.stringify(registroNuevoPP);
                    /**___________________________________________________________________________ */
                    //Se asigna el valor de la fecha de la carga
                    const fechacarga = Moment(new Date()).format("YYYY-MM-DD");
                    const horacarga = Moment(new Date()).format("HH:mm");
                    const fechahoracarga = Moment(fechacarga + " " + horacarga).format("YYYY-MM-DD HH:mm");
                    const piezasfechayhora = registroNuevoPP.cantidadPiezasCargando + " " + fechahoracarga;
                    registroNuevoPP.cargaFechaHora = piezasfechayhora;
                    resultado.mensaje = "Revisando reciba; 3-1: " + JSON.stringify(pproduccionGID);
                    //Creación o actualización de registro en pProducción   
                    const datosCarga = {
                        produccionGID: pproduccionGID.id, fechaDePlaneacion: registroNuevoPP.fechaDePlaneacion,
                        fecha: fechacarga, hora: horacarga, cantidadPiezas: registroNuevoPP.cantidadPiezasCargando,
                        materialEnCantidad: registroNuevoPP.materialEnCantidad, racks: registroNuevoPP.rackCarga,
                        piezasenCarga: registroNuevoPP.cantidadPiezasCargando, ciclos: registroNuevoPP.cicloCarga,
                        numeroRackCarga: registroNuevoPP.numeroRackCarga ? registroNuevoPP.numeroRackCarga : "",
                        Reg_Ins_Usuario: userName, modulo: moduloCP, rackTipo: registroNuevoPP.rackTipo
                    }
                    resultado.mensaje = "Revisando reciba; 3-2";
                    const recibaDatosA = await GetRecibaSerialesID(registroNuevoPP.recibaSerialID);
                    if (recibaDatosA.id) {
                        //Se cambia la ubicación del material de almacén a carga
                        const loacionAnterior = "";
                        const ubicacionAnterior = "Almacén";
                        const loacionPiezas = "Carga";;
                        const ubicacionPiezas = "Producción";
                        const cantidadPiezas = registroNuevoPP.cantidadPiezasCargando;
                        var cambioUbicacionAux = [];
                        resultado.mensaje = "Antes de obtener los datos del cambio de ubicación";
                        cambioUbicacionAux = await cambioUbicacionSeriales(
                            recibaDatosA,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas);
                        resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material 5";//"Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAux);
                        if (cambioUbicacionAux.mensaje != "") {
                            resultado.mensaje = cambioUbicacionAux.mensaje;
                            resultado.color = cambioUbicacionAux.color;
                            return resultado;
                        } else {
                            recibaDatosA.ultimaUbicacion = cambioUbicacionAux.sUltimaU;
                            recibaDatosA.rubicaciones = cambioUbicacionAux.sUbicaciones
                            resultado.mensaje = "Ubicaciones agrupadas";
                        }

                        const reciba = recibaDatosA;
                        const datosCargandor = reciba.registroCarga ? reciba.registroCarga : [];
                        await datosCargandor.push(datosCarga);
                        delete reciba.updatedAt;
                        delete reciba.__typename;
                        delete reciba.createdAt;
                        delete reciba.piezasCtnaRecuperadas;
                        delete reciba.piezasInspeccion;
                        delete reciba.piezasInspeccionPC;
                        delete reciba.piezasIRecuperacion;
                        delete reciba.piezasCRecuperacion;
                        delete reciba.PiezasCtnaRecuperacion;
                        delete reciba.piezasTRecuperacion;
                        delete reciba.piezasRecuperadas;
                        reciba.piezasenCarga = !reciba.piezasenCarga ?
                            registroNuevoPP.cantidadPiezasCargando : parseInt(reciba.piezasenCarga) +
                            parseInt(registroNuevoPP.cantidadPiezasCargando);
                        reciba.piezasenAlmacen = reciba.piezasenAlmacen - registroNuevoPP.cantidadPiezasCargando;
                        reciba.Reg_Mod_Usuario = userName;
                        reciba.cantidadPlaneada = (parseInt(registroNuevoPP.cantidadPlaneadaOriginal) + parseInt(registroNuevoPP.cantidadPiezasCargando));
                        //Datos de plandeproducción
                        reciba.racks = parseFloat(reciba.racks ? reciba.racks : 0) + parseFloat(registroNuevoPP.rackCarga);
                        reciba.ciclos = parseInt(reciba.ciclos ? reciba.ciclos : 0) + parseInt(registroNuevoPP.cicloCarga);
                        reciba.ultimoRack = registroNuevoPP.numeroRackCarga;
                        reciba.numeroCarga = (reciba.numeroCarga ? reciba.numeroCarga : 0) + 1;
                        reciba.registroCarga = datosCargandor;
                        reciba.cargaFechaHora = registroNuevoPP.cargaFechaHora;
                        resultado.mensaje = "Problemas al actualizar los datos de reciba " + JSON.stringify(reciba);//+ JSON.stringify(pProduccion) 
                        let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: reciba } });
                        const recibaU = upRecibaS.data.updateRecibaSeriales;

                        //Se actualizan los datos en recibaSerialesMP
                        const recibaSerialMPID = reciba.recibaSerialMPID;
                        if (reciba.recibaSerialMPID) {
                            delete reciba.recibaSerialMPID;
                            resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaDatosA);
                            await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...reciba, id: recibaSerialMPID, rsUpdatedAt: recibaU.updatedAt } }, });
                        }
                        //Se registra el dato de Resultado de operación
                        registroNuevoPP.piezasenCargando = registroNuevoPP.cantidadPiezasCargando;
                        const rOperacion = await manageResumenOperacion(fechacarga, registroNuevoPP, "Producción", userName, pproduccionGID.id);

                    } else {
                        resultado.mensaje = "Operación errónea, no se encontraron registros de ubicación disponible";
                        resultado.color = "warning";
                        return resultado;
                    }
                } else {
                    resultado.mensaje = "No fue posible realizar la operación: la cantidad debe ser mayor a cero";
                    resultado.color = "warning";
                    return resultado;
                }
                /**___________________________________________________________________________ */
                resultado.mensaje = "Operación exitosa; Se registró el material en la planeación y plan de producción correspondiente y se marcó en carga ";
                resultado.color = "primary";
                resultado.completo = true;
                return resultado;

            } else { //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
                resultado.mensaje = "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
                    " volver a intentarlo";
                resultado.color = "warning";
                return resultado;
            }

        }

    } catch (e) {
        resultado.color = "warning";
        return resultado;
    }
};
export async function guardarCargaPintadoPC(registroNuevoPP, userName, moduloCP, idProduccionGeneral, sporNPU, recibaOriginal) {
    // toggle();
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [], pproduccionGID: "" };
    //subscriptions.unsubscribe();
    try {
        if (!registroNuevoPP.productoID || !registroNuevoPP.cliente || !registroNuevoPP.numerodeParte ||
            !registroNuevoPP.cantidadPiezas || !registroNuevoPP.racksPC || !registroNuevoPP.ciclosPC ||
            !registroNuevoPP.fechaDePlaneacion || registroNuevoPP.cantidadDisponible < registroNuevoPP.cantidadPiezas ||
            !registroNuevoPP.cicloCarga || registroNuevoPP.cantidadDisponible < (sporNPU === false ? registroNuevoPP.cantidadPiezasCargando :
                registroNuevoPP.cantidadDisponible) || (registroNuevoPP.cantidadPiezasCargando > registroNuevoPP.cantidadPiezas && sporNPU === false) ||
            (sporNPU === false && (!registroNuevoPP.cantidadPiezasCargando || !registroNuevoPP.rackCarga))) {
            resultado.mensaje = "Faltan datos o son erróneos: los campos marcados con un asterisco son obligatorios," +
                " la cantidad del material agregado no pude ser mayor a la cantidad disponible ni a la cantidad planeada, se marcan en rojo los datos erróneos.";
            resultado.color = "warning";
        } else {
            //Variables auxiliares
            var numeroUP = 1;
            var pConcurrencia = false;
            const fechaPlaneacion = registroNuevoPP.fechaDePlaneacion;
            var pproduccionGID = {};
            var pproduccionIDS = [];
            var rSerialesIDS = [];
            //Se revisa la concurrencia en recibaSeriales si se trata de agregado individual (manual)
            if (sporNPU === false) {
                //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca activo igual a falso  en planeaciones
                const recibaDatosA = await GetRecibaSerialesID(recibaOriginal.id);
                if (!recibaDatosA.id) {//Si no se obtuvieron datos, se determina que hay concurrencia
                    pConcurrencia = true;
                } else if (recibaDatosA.cantidadPlaneadaPC != recibaOriginal.cantidadPlaneadaPC) {//Si la cantidad planeada se modificó, se marca como concurrencia
                    pConcurrencia = true;
                }
            }
            if (pConcurrencia === false) {
                //Se obtienen los planes de producción con la fecha del plan de producción en cuestión.                
                resultado.mensaje = "Obteniendo datos; 1";
                var pproduccionF = {};
                if (idProduccionGeneral) {
                    resultado.mensaje = "Obteniendo datos; 1-1";
                    const ppg = await GetPProduccionGeneralID(idProduccionGeneral);
                    if (ppg.id) {
                        pproduccionF = ppg;
                    }
                } else {
                    resultado.mensaje = "Obteniendo datos; 1-2";
                    const ppg = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { activo: { eq: true } }] });
                    if (ppg.length > 0) {
                        pproduccionF = ppg[0];
                    }
                    resultado.mensaje = "Obteniendo datos; 1-3";
                }

                //Si es una inserción, se obtiene el número que le corresponde        
                //Se revisa si ya existe un plan de producción con la fecha de hoy
                if (pproduccionF.id) { //Si existe el plan de producción, se obtiene el número de plan de producción y se agrega el id del serial .
                    numeroUP = pproduccionF.numero;
                    pproduccionGID = pproduccionF;
                    //Se actualiza el registro general de plan de producción.          
                    if (pproduccionGID.id) {
                        const pproduccionG = pproduccionF;
                        const datoRepetido = pproduccionG.recibaSerialIDS ? await pproduccionG.recibaSerialIDS.filter(datosPProduccion =>
                            datosPProduccion.includes(registroNuevoPP.recibaSerialID)) : [];
                        if (!datoRepetido[0]) {
                            const brecibaSerialIDS = pproduccionG.recibaSerialIDS ?
                                [...pproduccionG.recibaSerialIDS, { id: registroNuevoPP.recibaSerialID }] :
                                [{ id: registroNuevoPP.recibaSerialID }];

                            const rPProduccion = {
                                ...pproduccionG,
                                recibaSerialIDS: brecibaSerialIDS,
                                Reg_Mod_Usuario: userName
                            };

                            delete rPProduccion.createdAt;
                            delete rPProduccion.updatedAt;
                            delete rPProduccion.__typename;
                            resultado.mensaje = "Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion);
                            await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
                        }
                    }
                } else { //Si no existe, se crea el número de plan de producción en la tabla PProduccionUltimoNumero
                    resultado.mensaje = "Obteniendo datos; 2";
                    const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                    const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                    await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                        numeroUP = ultimaplaneacion.numero + 1;
                        ultimaplaneacion.numero = numeroUP;

                        delete ultimaplaneacion.createdAt;
                        delete ultimaplaneacion.updatedAt;
                        delete ultimaplaneacion.__typename;
                        ultimaplaneacion.Reg_Mod_Usuario = userName;
                        await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                        return ultimaplaneacion;
                    }))
                    if (!ultimapFromAPI.length) {
                        await API.graphql({
                            query: createPProduccionUltimoNumero, variables: {
                                input: {
                                    numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                                }
                            }
                        });
                    }
                    //Se crea el registro de la plan de producción general
                    resultado.mensaje = "Problemas al guardar la planeación general 1-CP";
                    let resulppg = await API.graphql({
                        query: createPProduccionGeneral, variables: {
                            input: {
                                fechaDePlaneacion: fechaPlaneacion,
                                numero: numeroUP,
                                espacioVacio: 0,
                                porSerial: true,
                                recibaSerialIDS: [{ id: registroNuevoPP.recibaSerialID }],
                                activo: true,
                                Reg_Ins_Usuario: userName
                            }
                        }
                    });
                    pproduccionGID = resulppg.data.createPProduccionGeneral;
                }

                //_________________________________________________________________
                //Se inician los trabajos en planeación, plan de producción y RecibaSeriales
                resultado.mensaje = "Revisando reciba; 1";
                var datosPPS = [];
                var productosID = {};
                var cantidadPPS = parseFloat(registroNuevoPP.cantidadPiezas);
                const racksXPiezas = parseFloat(registroNuevoPP.racksPC) / parseFloat(registroNuevoPP.cantidadPiezas);
                resultado.mensaje = "Revisando reciba; 2";

                //Se revisa si la cantidad cantidadPPS es menor que 0
                if (cantidadPPS > 0) {
                    resultado.mensaje = "Revisando reciba; 3" + JSON.stringify(registroNuevoPP);
                    /**___________________________________________________________________________ */
                    //Se asigna el valor de la fecha de la carga
                    const fechacarga = Moment(new Date()).format("YYYY-MM-DD");
                    const horacarga = Moment(new Date()).format("HH:mm");
                    const fechahoracarga = Moment(fechacarga + " " + horacarga).format("YYYY-MM-DD HH:mm");
                    const piezasfechayhora = registroNuevoPP.cantidadPiezasCargando + " " + fechahoracarga;
                    registroNuevoPP.cargaFechaHoraPC = piezasfechayhora;
                    resultado.mensaje = "Revisando reciba; 3-1: " + JSON.stringify(pproduccionGID);
                    //Creación o actualización de registro en pProducción   
                    const datosCarga = {
                        produccionGID: pproduccionGID.id, fechaDePlaneacion: registroNuevoPP.fechaDePlaneacion,
                        fecha: fechacarga, hora: horacarga, cantidadPiezas: registroNuevoPP.cantidadPiezasCargando,
                        materialEnCantidad: registroNuevoPP.materialEnCantidad, racks: registroNuevoPP.rackCarga,
                        piezasenCarga: registroNuevoPP.cantidadPiezasCargando, ciclos: registroNuevoPP.cicloCarga,
                        numeroRackCarga: registroNuevoPP.numeroRackCarga ? registroNuevoPP.numeroRackCarga : "",
                        Reg_Ins_Usuario: userName, modulo: moduloCP, rackTipo: registroNuevoPP.rackTipo
                    }
                    resultado.mensaje = "Revisando reciba; 3-2";
                    const recibaDatosA = await GetRecibaSerialesID(registroNuevoPP.recibaSerialID);
                    if (recibaDatosA.id) {
                        //Variable auxiliar para determinar a donde debe ir el material
                        const deAlmacen = ((!recibaDatosA.Ecoat && (recibaDatosA.precioUnitario ? recibaDatosA.precioUnitario : 0) === 0) &&
                            recibaDatosA.Pcoat === true) ? true : false;
                        //Se cambia la ubicación del material de almacén a carga
                        const loacionAnterior = deAlmacen ? "" : "Calidad";
                        const ubicacionAnterior = deAlmacen ? "Almacén" : "Producción";
                        const loacionPiezas = "Carga";
                        const ubicacionPiezas = "Producción-P";
                        const cantidadPiezas = registroNuevoPP.cantidadPiezasCargando;
                        var cambioUbicacionAux = [];
                        resultado.mensaje = "Antes de obtener los datos del cambio de ubicación";
                        cambioUbicacionAux = await cambioUbicacionSeriales(
                            recibaDatosA,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas);
                        resultado.mensaje = "Operación denegada: No se pudo determinar la ubicación del material 5";//"Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAux);
                        if (cambioUbicacionAux.mensaje != "") {
                            resultado.mensaje = cambioUbicacionAux.mensaje;
                            resultado.color = cambioUbicacionAux.color;
                            return resultado;
                        } else {
                            recibaDatosA.ultimaUbicacion = cambioUbicacionAux.sUltimaU;
                            recibaDatosA.rubicaciones = cambioUbicacionAux.sUbicaciones
                            resultado.mensaje = "Ubicaciones agrupadas";
                        }

                        const reciba = recibaDatosA;
                        const datosCargandor = reciba.registroCargaPC ? reciba.registroCargaPC : [];
                        await datosCargandor.push(datosCarga);
                        delete reciba.updatedAt;
                        delete reciba.__typename;
                        delete reciba.createdAt;
                        delete reciba.piezasCtnaRecuperadas;
                        delete reciba.piezasInspeccion;
                        delete reciba.piezasInspeccionPC;
                        delete reciba.piezasIRecuperacion;
                        delete reciba.piezasCRecuperacion;
                        delete reciba.PiezasCtnaRecuperacion;
                        delete reciba.piezasTRecuperacion;
                        delete reciba.piezasRecuperadas;
                        reciba.piezasenCargaPC = !reciba.piezasenCargaPC ?
                            registroNuevoPP.cantidadPiezasCargando : parseInt(reciba.piezasenCargaPC) +
                            parseInt(registroNuevoPP.cantidadPiezasCargando);
                        if ((!reciba.Ecoat && (reciba.precioUnitario ? reciba.precioUnitario : 0) === 0) && reciba.Pcoat === true) {
                            reciba.piezasenAlmacen = reciba.piezasenAlmacen - registroNuevoPP.cantidadPiezasCargando;
                        }

                        reciba.Reg_Mod_Usuario = userName;
                        reciba.cantidadPlaneadaPC = (parseInt(registroNuevoPP.cantidadPlaneadaOriginal) + parseInt(registroNuevoPP.cantidadPiezasCargando));
                        //Datos de plandeproducción
                        reciba.racksPC = parseFloat(reciba.racksPC ? reciba.racksPC : 0) + parseFloat(registroNuevoPP.rackCarga);
                        reciba.ciclosPC = parseInt(reciba.ciclosPC ? reciba.ciclosPC : 0) + parseInt(registroNuevoPP.cicloCarga);
                        reciba.ultimoRackPC = registroNuevoPP.numeroRackCarga;
                        reciba.numeroCargaPC = (reciba.numeroCargaPC ? reciba.numeroCargaPC : 0) + 1;
                        reciba.registroCargaPC = datosCargandor;
                        reciba.cargaFechaHoraPC = registroNuevoPP.cargaFechaHoraPC;
                        resultado.mensaje = "Problemas al actualizar los datos de reciba " + JSON.stringify(reciba);//+ JSON.stringify(pProduccion) 
                        let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: reciba } });
                        const recibaU = upRecibaS.data.updateRecibaSeriales;

                        //Se actualizan los datos en recibaSerialesMP
                        const recibaSerialMPID = reciba.recibaSerialMPID;
                        if (reciba.recibaSerialMPID) {
                            delete reciba.recibaSerialMPID;
                            resultado.mensaje = "Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaDatosA);
                            await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...reciba, id: recibaSerialMPID, rsUpdatedAt: recibaU.updatedAt } }, });
                        }
                        //Se registra el dato de Resultado de operación
                        // registroNuevoPP.piezasenCargando = registroNuevoPP.cantidadPiezasCargando;
                        // const rOperacion = await manageResumenOperacion(fechacarga, registroNuevoPP, "Producción", userName, pproduccionGID.id);

                    } else {
                        resultado.mensaje = "Operación errónea, no se encontraron registros de ubicación disponible";
                        resultado.color = "warning";
                        return resultado;
                    }
                } else {
                    resultado.mensaje = "No fue posible realizar la operación: la cantidad debe ser mayor a cero";
                    resultado.color = "warning";
                    return resultado;
                }
                /**___________________________________________________________________________ */
                resultado.mensaje = "Operación exitosa; Se registró el material en la planeación y plan de producción correspondiente y se marcó en carga ";
                resultado.color = "primary";
                resultado.completo = true;
                return resultado;

            } else { //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
                resultado.mensaje = "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
                    " volver a intentarlo";
                resultado.color = "warning";
                return resultado;
            }

        }

    } catch (e) {
        resultado.color = "warning";
        return resultado;
    }
};
//Registra o actualiza los datos del resumen de operación
export async function manageResumenOperacion(fecha, datos, modulo, userName, datoGenID) {
    var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, registros: [], pproduccionGID: "" };
    try {//Revisa que no falten datos

        //Se guardan los registros en ResumenOperacion
        //const fecha = Moment(new Date()).format("YYYY-MM-DD");
        resultado.mensaje = "Obteniendo datos; 1";
        const robti = await GetResumenOperacion({ and: [{ fecha: { eq: fecha } }, { activo: { eq: true } }] });
        resultado.mensaje = "Obteniendo datos; 2";
        //Se actualiza el registro general de plan de producción.          
        if (robti.length > 0) {
            const resumeO = robti[0];
            const datoRepetido = resumeO.recibaSerialIDS ? await resumeO.recibaSerialIDS.filter(datosPProduccion =>
                datosPProduccion.includes(datos.recibaSerialID)) : [];
            if (!datoRepetido[0]) {
                const brecibaSerialIDS = resumeO.recibaSerialIDS ?
                    [...resumeO.recibaSerialIDS, { id: datos.recibaSerialID }] :
                    [{ id: datos.recibaSerialID }];

                resumeO.recibaSerialIDS = brecibaSerialIDS;
            }
            //Si los módulos son InspeccionF ó Producción
            if (modulo === "InspeccionF" || modulo === "Producción") {
                //Se obtienen los datos del plan de producción general
                const pProduccionGen = await GetPProduccionGeneralID(datoGenID);
                if (pProduccionGen.id) {
                    //Se asignan los valores a los campos correspondientes de Inspección final
                    if (modulo === "InspeccionF") {
                        const piezasTotales = (parseInt(datos.piezasEnInspeccionando ? datos.piezasEnInspeccionando : 0) +
                            parseInt(datos.piezasNoAceptadas ? datos.piezasNoAceptadas : 0));
                        const piezasTotalesPrecio = (datos.precioUnitario ? parseFloat(parseFloat(piezasTotales) * parseFloat(datos.precioUnitario)) : 0);

                        resumeO.totalInspeccionado = parseInt(resumeO.totalInspeccionado ? resumeO.totalInspeccionado : 0) + piezasTotales;
                        resumeO.facturadoPendientePorEmbarcar = parseInt(resumeO.facturadoPendientePorEmbarcar ? resumeO.facturadoPendientePorEmbarcar : 0)
                            + piezasTotalesPrecio;
                        resumeO.facturacionTotaldelDia = parseFloat(resumeO.facturacion ? resumeO.facturacion : 0) +
                            parseFloat(resumeO.facturadoPendientePorEmbarcar ? resumeO.facturadoPendientePorEmbarcar : 0);
                        resumeO.materialPendienteporInspeccion = resumeO.materialPendienteporInspeccion ? parseFloat(resumeO.materialPendienteporInspeccion) -
                            piezasTotalesPrecio : piezasTotalesPrecio;
                        if (resumeO.defectuso && resumeO.totalInspeccionado) {
                            resumeO.porcentajeDefectuoso = (parseFloat(resumeO.defectuso ?
                                resumeO.defectuso : 0) * 100) / parseFloat(resumeO.totalInspeccionado ? resumeO.totalInspeccionado : 0);
                        }
                    }
                    //Se asignan los valores a los campos correspondientes a producción
                    if (modulo === "Producción") {
                        //Si se está registrando una carga
                        //Se asigna el valor de los espacios vacíos
                        resumeO.ecEspaciosVacios = (pProduccionGen.espacioVacio ? pProduccionGen.espacioVacio : 0);
                        if (datos.piezasenCargando) {
                            //Se determina el precio de la cantidad cargando
                            resumeO.ecCargados = parseFloat(resumeO.ecCargados ? resumeO.ecCargados : 0) + parseFloat(datos.rackCarga ? datos.rackCarga : 0);
                            resumeO.eficienciaCargaRacks = ((resumeO.ecCargados + resumeO.ecEspaciosVacios) * 100) / parseInt(resumeO.ecCapacidadLinea);
                            resumeO.ecEFvsPP = (resumeO.ecCargados * 100) / parseInt(resumeO.ecProgramados ? resumeO.ecProgramados : 0);
                            resumeO.ecPorcentajePerdido = 100 - resumeO.eficienciaCargaRacks;
                        }
                        if (datos.piezasEnpintando) {
                            //Se asigna el valor de los 
                            const piezasTotalesPrecio = (datos.precioUnitario ? (parseFloat(datos.piezasEnpintando ? datos.piezasEnpintando : 0) * parseFloat(datos.precioUnitario)) : 0);
                            resumeO.materialPendienteporInspeccion = resumeO.materialPendienteporInspeccion ? parseFloat(resumeO.materialPendienteporInspeccion) +
                                piezasTotalesPrecio : piezasTotalesPrecio;
                        }

                    }
                }
            }


            if (modulo === "PlaneaciónBase") {
                //Se obtienen los datos de la planeación base
                const planeacionB = await GetPlaneacionBaseGeneralID(datoGenID);
                if (planeacionB.PlaneacionBIDS) {
                    const pb = await ObtenerSerialesPlaneacionBase(planeacionB.PlaneacionBIDS);
                    if (pb.racks) {
                        resumeO.ecProgramados = pb.racks;
                        resumeO.ecCapacidadLineaProgramada = (pb.racks * 100) / resumeO.ecCapacidadLinea;
                        resumeO.ecEFvsPP = (parseFloat(resumeO.ecCargados ? resumeO.ecCargados : 0) * 100) /
                            parseInt(resumeO.ecProgramados ? resumeO.ecProgramados : 0);
                        resumeO.facturacionPlaneada = pb.costoTotalD;
                        resumeO.diferenciaVSPlaneado = parseFloat(resumeO.facturacion ? resumeO.facturacion : 0) - pb.costoTotalD;
                        resumeO.diferenciaPorcentaje = (resumeO.diferenciaVSPlaneado * 100) / parseFloat(resumeO.facturacion ? resumeO.facturacion : 0);
                        resumeO.costoQuimicovsFacturacion = (parseFloat(resumeO.gastosQuimicos ? resumeO.gastosQuimicos : 0) * 100) /
                            parseFloat(resumeO.facturacionPlaneada ? resumeO.facturacionPlaneada : 0);
                    }
                }
            }
            if (modulo === "Embarques") {

                //facturacion
                //Se asigna el valor de los 
                const piezasTotales = (parseInt(datos.piezasPintadas ? datos.piezasPintadas : 0) +
                    parseInt(datos.piezasNRecuperadas ? datos.piezasNRecuperadas : 0) +
                    parseInt(datos.piezasNoPintadas ? datos.piezasNoPintadas : 0));
                const piezasTotalesPrecio = (datos.precioUnitario ? (parseFloat(piezasTotales) * parseFloat(datos.precioUnitario)) : 0);
                resumeO.facturacion = resumeO.facturacion ? parseFloat(resumeO.facturacion) +
                    piezasTotalesPrecio : piezasTotalesPrecio;
                //facturadoPendientePorEmbarcar
                resumeO.facturadoPendientePorEmbarcar = parseInt(resumeO.facturadoPendientePorEmbarcar ? resumeO.facturadoPendientePorEmbarcar : 0)
                    - piezasTotalesPrecio;
                //facturacionTotaldelDia
                resumeO.facturacionTotaldelDia = parseFloat(resumeO.facturacion ? resumeO.facturacion : 0) +
                    parseFloat(resumeO.facturadoPendientePorEmbarcar ? resumeO.facturadoPendientePorEmbarcar : 0);
                //diferenciaVSPlaneado
                resumeO.diferenciaVSPlaneado = parseFloat(resumeO.facturacion ? resumeO.facturacion : 0) - parseFloat(resumeO.facturacionPlaneada ? resumeO.facturacionPlaneada : 0);
                //diferenciaPorcentaje
                resumeO.diferenciaPorcentaje = (resumeO.diferenciaVSPlaneado * 100) / parseFloat(resumeO.facturacion ? resumeO.facturacion : 0);
                //  inventarioOperacion
                if (datos.piezasEnPlanta === false) {
                    //Se obtienen los datos del inventario
                    const inventario = await ObtenerInventario();
                    resumeO.materialPendienteporInspeccion = parseFloat(inventario.totalPintadoPI ? inventario.totalPintadoPI : 0);
                    resumeO.inventarioOperacion = inventario.inventarioClientes;
                    resumeO.inventario = inventario.totalInventario;
                }
            }
            if (modulo === "Reciba") {
                //Se obtienen los datos del inventario
                const inventario = await ObtenerInventario();
                resumeO.materialPendienteporInspeccion = parseFloat(inventario.totalPintadoPI ? inventario.totalPintadoPI : 0);
                resumeO.inventarioOperacion = inventario.inventarioClientes;
                resumeO.inventario = inventario.totalInventario;
            }
            delete resumeO.createdAt;
            delete resumeO.updatedAt;
            delete resumeO.__typename;
            resultado.mensaje = "Problemas al actualizar el plan de ResumenOperacion " + JSON.stringify(resumeO);
            await API.graphql({ query: updateResumenOperacion, variables: { input: resumeO } });
        } else { //Si no existe, se crea el registro en ResumenOperacion.
            resultado.mensaje = "Obteniendo datos; 3";
            //Se crea el registro en ResumenOperacion
            //Se obtienen los datos de los campos que llevan valores por default de la tabla aDatosROperacion
            resultado.mensaje = "Problemas al guardar ResumenOperacion";
            const datosDefaultRO = await GetADatosROperacion({ activo: { eq: true } });
            const resumeO = {
                fecha: fecha,
                ecCapacidadLinea: parseInt(datosDefaultRO[0].ecCapacidadLinea ? datosDefaultRO[0].ecCapacidadLinea : 200),
                objetivoFacturacion: parseInt(datosDefaultRO[0].objetivoFacturacion ? datosDefaultRO[0].objetivoFacturacion : 15000),
                metaVentaCumplimientoKPI: parseInt(datosDefaultRO[0].metaVentaCumplimientoKPI ? datosDefaultRO[0].metaVentaCumplimientoKPI : 12500),
                recibaSerialIDS: [{ id: datos.recibaSerialID }],
                activo: true,
                Reg_Ins_Usuario: userName
            }
            //Se asignan los valores a los campos correspondientes de Inspección final
            if (modulo === "InspeccionF") {
                const piezasTotales = (parseInt(datos.piezasEnInspeccionando ? datos.piezasEnInspeccionando : 0) +
                    parseInt(datos.piezasNoAceptadas ? datos.piezasNoAceptadas : 0));
                resumeO.totalInspeccionado = piezasTotales;
                if (resumeO.defectuso && resumeO.totalInspeccionado) {
                    resumeO.porcentajeDefectuoso = (parseFloat(resumeO.defectuso ?
                        resumeO.defectuso : 0) * 100) / parseFloat(resumeO.totalInspeccionado ? resumeO.totalInspeccionado : 0);
                }
            }
            //Se asignan los valores a los campos correspondientes de Inspección final
            /* const pProduccionGen = await GetPProduccionGeneralID(datoGenID)
             if (pProduccionGen.id) {
                 //Se obtienen los datos del plan de producción con los datos obtenidos previamente del plan de producción general
                 const PProduccion = await ObtenerSerialesPProduccion(pProduccionGen);
                 //Se asignan los datos obtenidos de totalInspeccionado
                 resumeO.totalInspeccionado = (PProduccion.totalInspeccionado ? PProduccion.totalInspeccionado : 0);
             }*/
            //Se asignan los valores a los campos correspondientes a producción
            if (modulo === "Producción") {
                //Se asigna el valor de los espacios vacíos
                resumeO.ecEspaciosVacios = 0;
                if (datos.piezasenCargando) {
                    resumeO.ecCargados = parseFloat(resumeO.ecCargados ? resumeO.ecCargados : 0) + parseFloat(datos.rackCarga ? datos.rackCarga : 0);
                    resumeO.eficienciaCargaRacks = ((resumeO.ecCargados + resumeO.ecEspaciosVacios) * 100) / parseInt(resumeO.ecCapacidadLinea);
                    resumeO.ecEFvsPP = (resumeO.ecCargados * 100) / parseInt(resumeO.ecProgramados ? resumeO.ecProgramados : 0);
                    resumeO.ecPorcentajePerdido = 100 - resumeO.eficienciaCargaRacks;

                }

            }

            //Se obtienen los datos de la planeación base
            if (modulo === "PlaneaciónBase") {
                //Se obtienen los datos de la planeación base
                const planeacionB = await GetPlaneacionBaseGeneralID(datoGenID);
                if (planeacionB.PlaneacionBIDS) {
                    const pb = await ObtenerSerialesPlaneacionBase(planeacionB.PlaneacionBIDS);
                    if (pb.racks) {
                        resumeO.ecProgramados = pb.racks;
                        resumeO.ecCapacidadLineaProgramada = (pb.racks * 100) / resumeO.ecCapacidadLinea
                        resumeO.ecEFvsPP = (parseFloat(resumeO.ecCargados ? resumeO.ecCargados : 0) * 100) /
                            parseInt(resumeO.ecProgramados ? resumeO.ecProgramados : 0);
                        resumeO.facturacionPlaneada = pb.costoTotalD;
                        resumeO.diferenciaVSPlaneado = parseFloat(resumeO.facturacion ? resumeO.facturacion : 0) - pb.costoTotalD;
                        resumeO.diferenciaPorcentaje = (resumeO.diferenciaVSPlaneado * 100) / parseFloat(resumeO.facturacion ? resumeO.facturacion : 0);
                        resumeO.costoQuimicovsFacturacion = (parseFloat(resumeO.gastosQuimicos ? resumeO.gastosQuimicos : 0) * 100) /
                            parseFloat(resumeO.facturacionPlaneada ? resumeO.facturacionPlaneada : 0);
                    }
                }
            }
            if (modulo === "Embarques") {

                //facturacion
                //Se asigna el valor de los 
                const piezasTotales = (parseInt(datos.piezasPintadas ? datos.piezasPintadas : 0) +
                    parseInt(datos.piezasNRecuperadas ? datos.piezasNRecuperadas : 0) +
                    parseInt(datos.piezasNoPintadas ? datos.piezasNoPintadas : 0));
                const piezasTotalesPrecio = (datos.precioUnitario ? (parseFloat(piezasTotales) * parseFloat(datos.precioUnitario)) : 0);
                resumeO.facturacion = resumeO.facturacion ? parseFloat(resumeO.facturacion) +
                    piezasTotalesPrecio : piezasTotalesPrecio;
                //diferenciaVSPlaneado
                resumeO.diferenciaVSPlaneado = parseFloat(resumeO.facturacion ? resumeO.facturacion : 0) - parseFloat(resumeO.facturacionPlaneada ? resumeO.facturacionPlaneada : 0);
                //diferenciaPorcentaje
                resumeO.diferenciaPorcentaje = (resumeO.diferenciaVSPlaneado * 100) / parseFloat(resumeO.facturacion ? resumeO.facturacion : 0);
                //  inventarioOperacion
            }

            //Se obtienen los datos del inventario
            const inventario = await ObtenerInventario();
            //Se asignan lo datos obtenidos de facturadoPendientePorEmbarcar
            resumeO.facturadoPendientePorEmbarcar = parseInt(inventario.facturadoPE ? inventario.facturadoPE : 0);
            resumeO.facturacionTotaldelDia = resumeO.facturadoPendientePorEmbarcar +
                parseInt(resumeO.facturacion ? resumeO.facturacion : 0);
            resumeO.materialPendienteporInspeccion = parseFloat(inventario.totalPintadoPI ? inventario.totalPintadoPI : 0);
            resumeO.inventarioOperacion = inventario.inventarioClientes;
            resumeO.inventario = inventario.totalInventario;


            let resulppg = await API.graphql({ query: createResumenOperacion, variables: { input: resumeO } });

        }

        /*resultado.mensaje = "Operación exitosa";*/ //, piezas totales: " + piezasTotales + ", piezas en pintado: " + pInspeccion.piezasenPintado
        resultado.color = "primary";
        resultado.completo = true;
        return resultado;


    } catch (e) {
        resultado.mensaje = e.message;
        resultado.color = "warning";
        return resultado;
    }

};
//libera una locación
export async function liberarlocacionb(locacion, espacio, userName) {
    try {
        delete locacion.createdAt;
        delete locacion.updatedAt;
        delete locacion.__typename;
        locacion.Reg_Mod_Usuario = userName;
        locacion.ocupado = false;
        locacion.fechaDeliberacion = new Date();
        locacion.recibaSerialID = "";
        locacion.recibaSerialMPID = "";
        locacion.espacioOcupado =
            locacion.espacioOcupado - espacio <= 0
                ? 0
                : locacion.espacioOcupado - espacio;

        //setMensajeAlert("Operación errónea; Problemas al liberar locación");
        await API.graphql({ query: updateLocacion, variables: { input: locacion } });
        /*window.scrollTo(0, 0);
        //setMensajeAlert("Operación exitosa");
        setColor("info");
        setAVisible(true);*/
    } catch (e) {
        /*window.scrollTo(0, 0);
        //setMensajeAlert("Hay problemas liberando las locaciones");
        setColor("warning");
        setAVisible(true);*/
    }
}